import React, { useContext, useEffect, useState } from 'react';
import {
  MixedGridGroup,
  QuantaFormik,
  QuantaForm,
  useResponsiveParams,
  useQuantaFormikContext,
  Text,
  Button,
  Label,
  Grid,
  GridItem,
  QuantaCheckbox,
  NotificationList,
  Paper,
  QuantaToggle,
  InputGrid
} from 'quanta-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { v4 as uuidv4 } from 'uuid';
import {
  faCalculator,
  faChevronRight,
  faExclamationTriangle,
  faMapMarkerAlt,
  faInfoCircle,
  faSave,
  faSpinner,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
// import { updateFireQuote } from '../../_graphql/state';
import { updateFireQuote } from 'quanta-flows/modules/quote/fire/state';
// import Loading from '../../../../../../lib/layout/loading';
import { Loading } from 'quanta-flows/modules/layout';
// import { ConfigContext } from '../../../../../../lib/config/ConfigProvider';
import { QuantaConfigContext } from 'quanta-flows';
// import Parse from '../../../../../../lib/intl/CurrencyFormater';
import { CurrencyFormater } from 'quanta-flows';
// import useFetchQuery from '../../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
import moment from 'moment';
import {
  CALC_PREMIUM_QUOTE_FIRE_SA,
  GET_SELECTED_INTERMEDIARY,
  PINCODE_LOOKUP,
  REMOVE_RISK_LOCATION,
  RISK_DROPDOWN_QUERIES,
  SAVE_LOCATION_FIRE,
  COVER_FIRESA,
  COST_OF_CONSTRUCTION
} from '../../queries';
import { useQuery } from '@apollo/client';
import StockLocationModal from './stock-location-modal';
import DeleteModal from './delete-modal';
// import { ModalViewBreakupFire } from '../../../../../common/view-breakup/exports';
import { ModalViewBreakupFire } from 'quanta-flows/modules/common/viewBreakUp';
import CancelModal from './cancel-modal';
// import useMutationQuery from '../../../../../../lib/graphql/useMutationQuery';
import { useMutationQuery } from 'quanta-flows';
import CustomerSummary from '../common/customer-summary';
// import AddOnCoveSA from './AddOnCovers_SA';

export default function RiskLocationNonFloaterDetails({
  fireQuote,
  goToStep,
  productCode,
  productName,
  lobCode,
  quoteNumber,
  lobName,
  riskCovers,
  basisOfValuation,
  renderExpandedCards,
  role,
  ...props
}) {
  const isQuoteReadOnly =
    [
      'quote saved',
      'underwriter approved',
      'underwriter rejected',
      'converted to proposal',
    ]?.includes(fireQuote?.status?.toString()?.toLowerCase()) ||
    (role?.toString()?.toLowerCase() !== 'underwriter' &&
      fireQuote?.status?.toString()?.toLowerCase() ===
      'pending uw approval');

  // console.log('if conditions',fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType &&
  // fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.length > 0)
  const fetchQuery = useFetchQuery();
  const mutateQuery = useMutationQuery();

  let repeatForMobile = 1,
    repeatForDesktop = 3,
    repeatForFireExtinguisherDetailsMobile = 1,
    repeatForFireExtinguisherDetailsDesktop = 2,
    repeatForMobileReadOnly = 2,
    repeatForDesktopReadOnly = 3,
    repeatTopDataForDesktop = 3,
    repeatTopDataForMobile = 2;
  let colSpan_for_Desktop = 3;
  const noOfColsMobile = 1,
    noOfColsDesktop = 3;
  const inputColSpans = useResponsiveParams({
    for_mobile: noOfColsMobile,
    for_desktop: noOfColsDesktop,
  });
  const { branding } = useContext(QuantaConfigContext);

  const { loading: loadingintermediary, error: errorintermediary, data: dataintermediary } = useQuery(
    GET_SELECTED_INTERMEDIARY,
  );
  const {
    loading: loadingRiskDropdownDetails,
    error: errorRiskDropdownDetails,
    data: dataRiskDropdownDetails,
  } = useQuery(RISK_DROPDOWN_QUERIES, {
    fetchPolicy: 'network-only',
    variables: {
      productCode: '1132',
    },
  });
  const {
    loading: loadingCoverFireSA,
    error: errorCoverFireSA,
    data: dataCoverFireSA,
  } = useQuery(COVER_FIRESA, {
    fetchPolicy: 'network-only',
    variables: {
      input:
      {
        productCode: '1132',
        intermediaryCode: fireQuote?.intermediaryDetails?.code
          ? fireQuote?.intermediaryDetails?.code
          : dataintermediary?.selectedIntermediary?.intermediaryCode,
        subProductName: fireQuote?.productKg || fireQuote?.productName,//"Kotak Bharat Griha Raksha",//drop //
        riskType: fireQuote?.customerDetails?.customerType?.value,//'Dwelling', 
        coverType: fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value, //'Home Contents' 
        eqZone: fireQuote?.eqZone,
        typeOfCover: fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value,
        basisOfValuation: fireQuote?.basisOfValuation
        // policyType: ' Policy'
      }
    },
  });
  const {
    loading: loadingCostOfConstruction,
    error: errorCostOfConstruction,
    data: dataCostOfConstruction,
  } = useQuery(COST_OF_CONSTRUCTION, {
    fetchPolicy: 'network-only',
    variables: {
      input:
      {
        productCode: '1132',
        pincode: fireQuote?.pincode ? fireQuote?.pincode : ""
      }
    },
  });
  // const {
  //   coverListForSA
  // } = dataCoverFireSA;

  // setCoversInfo(coverListForSA);
  // const {
  //   loading: loadingriskdropdownSA,
  //   error: errorriskdropdownSA,
  //   data: datariskdropdownSA,
  // } = useQuery(risk_dropdown_SA, {
  //   fetchPolicy: 'cache-first',
  //   variables: {
  //     productCode,
  //   },
  // });
  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });
  let repeatData = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: 2,
  });

  let repeatReadOnly = useResponsiveParams({
    for_mobile: repeatForMobileReadOnly,
    for_desktop: repeatForDesktopReadOnly,
  });

  let repeatForFireExtinguisherDetails = useResponsiveParams({
    for_mobile: repeatForFireExtinguisherDetailsMobile,
    for_desktop: repeatForFireExtinguisherDetailsDesktop,
  });

  let repeatTopData = useResponsiveParams({
    for_mobile: repeatTopDataForMobile,
    for_desktop: repeatTopDataForDesktop,
  });

  let screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
  });

  // useEffect(() => {
  //   console.log("useeffect", values);
  //   if (
  //     values?.customerDetails?.customerType?.value
  //     ?.toString()
  //     ?.toLowerCase() ===  'housing society'

  //   ) {
  //     setFieldValue(
  //       `riskLocations.occupancy.value`,
  //       `Dwelling`,
  //     );
  //   }


  //   else {

  //     setFieldValue(
  //       `riskLocations.occupancy.value`,
  //       'Dwellings: Cooperative Society',

  //     );
  //   }

  // }, [
  //   values?.customerDetails?.customerType?.value,

  // ]);
  const validate = (values) => {
    if (isQuoteReadOnly) {
      return {};
    }
    let errors = {};
    let errorCount = 0;
    let t;
    let round;
    let bvalue = 0;
    let avalue = 0;
    errors.riskLocations = {};
    // errors.addOnCovers = {};
    // let addOnCovers = values.addOnCovers
    // const propertyNames = Object.entries(addOnCovers);
    // console.log('propertyNames',propertyNames)
    // let addon1='Additional Living Expenses'
    // let addon2='Earthquake Fire and Shock'
    // let addon3='Involuntary Betterment Technological Advancement'
    // let addon4='Loss Minimization Expenses'
    // let addon5='Loss of Rent'
    // let addon6='Personal Accident Cover Self'
    // let addon7='Personal Accident Cover Spouse'
    // let addon8='Rent for an Alternative Accommodation'
    // let addon9='Specified Incidental Expenses Cover'
    // let addon10='Terrorism Damage Cover'
    //1
    // if(values['addOnCovers'][addon1].selected === true)
    // {
    //   console.log('Additional Living Expenses passing',values[`addOnCovers`][addon1][`attributes`][`additionalLivingExpensesSI`])
    //   errors[`addOnCovers`][addon1] ={
    //     attributes :{}
    //   }
    //   if(values[`addOnCovers`][addon1][`attributes`][`additionalLivingExpensesSI`].toString() === '0')
    //   {
    //     console.log('Additional Living Expenses passing validate')
    //   errors[`addOnCovers`][addon1][`attributes`][`additionalLivingExpensesSI`] =
    //   '* Required';
    //   errorCount += 1;
    //   }
    // }
    //3
    // if(values['addOnCovers'][addon3].selected === true)
    // {
    //   errors[`addOnCovers`][addon3] ={
    //     attributes :{}
    //   }
    //   if(values[`addOnCovers`][addon1][`attributes`][`involuntaryBettermentTechnologicalAdvancementSI`] === '')
    //   {
    //   errors[`addOnCovers`][addon3][`attributes`][`involuntaryBettermentTechnologicalAdvancementSI`] =
    //   '* Required';
    //   errorCount += 1;
    //   }
    // }
    // //4
    // if(values['addOnCovers'][addon4].selected === true)
    // {
    //   errors[`addOnCovers`][addon4] ={
    //     attributes :{}
    //   }
    //   if(values[`addOnCovers`][addon1][`attributes`][`involuntaryBettermentTechnologicalAdvancementSI`] === '')
    //   {
    //   errors[`addOnCovers`][addon4][`attributes`][`lossMinimizationExpensesSI`] =
    //   '* Required';
    //   errorCount += 1;
    //   }
    // }
    // //5
    // if(values['addOnCovers'][addon4].selected === true)
    // {
    //   errors[`addOnCovers`][addon5] ={
    //     attributes :{}
    //   }
    //   if(values[`addOnCovers`][addon1][`attributes`][`Indemnity_Period_Loss_of_Rent_In_Months`] === '')
    //   {
    //   errors[`addOnCovers`][addon5][`attributes`][`Indemnity_Period_Loss_of_Rent_In_Months`] =
    //   '* Required';
    //   errorCount += 1;
    //   }
    //   if(values[`addOnCovers`][addon1][`attributes`][`lossOfRentSI`] === '')
    //   {
    //   errors[`addOnCovers`][addon5][`attributes`][`lossOfRentSI`] =
    //   '* Required';
    //   errorCount += 1;
    //   }
    //   if(values[`addOnCovers`][addon1][`attributes`][`rentPerMonth`] === '')
    //   {
    //   errors[`addOnCovers`][addon5][`attributes`][`rentPerMonth`] =
    //   '* Required';
    //   errorCount += 1;
    //   }
    // }
    // //6
    // if(values['addOnCovers'][addon6].selected === true)
    // {
    //   errors[`addOnCovers`][addon6] ={
    //     attributes :{}
    //   }
    //   if(values[`addOnCovers`][addon6][`attributes`][`personalAccidentCoverSelfSI`] === '')
    //   {
    //   errors[`addOnCovers`][addon6][`attributes`][`personalAccidentCoverSelfSI`] =
    //   '* Required';
    //   errorCount += 1;
    //   }
    // }
    // //7
    // if(values['addOnCovers'][addon7].selected === true)
    // {
    //   errors[`addOnCovers`][addon7] ={
    //     attributes :{}
    //   }
    //   if(values[`addOnCovers`][addon7][`attributes`][`personalAccidentCoverSpouseSI`] === '')
    //   {
    //   errors[`addOnCovers`][addon7][`attributes`][`personalAccidentCoverSpouseSI`] =
    //   '* Required';
    //   errorCount += 1;
    //   }
    // }
    // //8
    // if(values['addOnCovers'][addon8].selected === true)
    // {
    //   errors[`addOnCovers`][addon8] ={
    //     attributes :{}
    //   }
    //   if(values[`addOnCovers`][addon8][`attributes`][`accomodationRentPerMonth`] === '')
    //   {
    //   errors[`addOnCovers`][addon8][`attributes`][`accomodationRentPerMonth`] =
    //   '* Required';
    //   errorCount += 1;
    //   }
    //   if(values[`addOnCovers`][addon8][`attributes`][`accomodationIndemnityPeriodInMonths`] === '')
    //   {
    //   errors[`addOnCovers`][addon8][`attributes`][`accomodationIndemnityPeriodInMonths`] =
    //   '* Required';
    //   errorCount += 1;
    //   }
    //   if(values[`addOnCovers`][addon8][`attributes`][`rentForAlternativeAccommodationSI`] === '')
    //   {
    //   errors[`addOnCovers`][addon8][`attributes`][`rentForAlternativeAccommodationSI`] =
    //   '* Required';
    //   errorCount += 1;
    //   }
    // }
    // //9
    // if(values['addOnCovers'][addon9].selected === true)
    // {
    //   errors[`addOnCovers`][addon9] ={
    //     attributes :{}
    //   }
    //   if(values[`addOnCovers`][addon9][`attributes`][`specifiedIncidentalExpensesCoverSI`] === '')
    //   {
    //   errors[`addOnCovers`][addon9][`attributes`][`specifiedIncidentalExpensesCoverSI`] =
    //   '* Required';
    //   errorCount += 1;
    //   }
    // }
    // errors.riskLocations.riskSumInsured = {};
    let decimalcheck;
    // if (!values?.riskLocations?.occupancy?.value) {
    //   errors.riskLocations.occupancy = {
    //     value: `* Required`,
    //   };
    //   errorCount += 1;
    // }
    if (!values?.riskLocations?.addressDetails?.addressLine1) {
      if (!errors?.riskLocations?.addressDetails) {
        errors.riskLocations.addressDetails = {};
      }
      errors.riskLocations.addressDetails.addressLine1 =
        '* Required';
      errorCount += 1;
    }
    // if(values?.riskLocations.riskSumInsured.buildingValue.length > 6)
    // {
    //   errors.riskLocations.riskSumInsured.buildingValue = 'it is greater'
    // }
    if (!values?.riskLocations?.addressDetails?.pincode) {
      if (!errors?.riskLocations?.addressDetails) {
        errors.riskLocations.addressDetails = {};
      }
      errors.riskLocations.addressDetails.pincode = '* Required';
      errorCount += 1;
    } else if (
      values?.riskLocations?.addressDetails?.pincode &&
      (values?.riskLocations?.addressDetails?.pincode?.length !==
        6 ||
        !values?.riskLocations?.addressDetails?.pincode?.match(
          /^[0-9]+$/,
        ))
    ) {
      if (!errors?.riskLocations?.addressDetails) {
        errors.riskLocations.addressDetails = {};
      }
      errors.riskLocations.addressDetails.pincode =
        '* Pincode must be of 6 digits';
      errorCount += 1;
    } else if (
      values?.riskLocations?.addressDetails?.pincode &&
      values?.riskLocations?.addressDetails?.pincode?.length ===
      6 &&
      (!values?.riskLocations?.addressDetails?.state ||
        !values?.riskLocations?.addressDetails?.district)
    ) {
      if (!errors?.riskLocations?.addressDetails) {
        errors.riskLocations.addressDetails = {};
      }
      errors.riskLocations.addressDetails.pincode =
        '* Click the search icon to fetch city, district and state';
      errorCount += 1;
    }
    if (fireQuote.basisOfValuation === 'Reinstatement value') {
      if (!values?.riskLocations?.riskSumInsured?.costOfConstruction) {
        if (!errors?.riskLocations?.riskSumInsured) {
          errors.riskLocations.riskSumInsured = {};
        }
        errors.riskLocations.riskSumInsured.costOfConstruction =
          '* Required';
        errorCount += 1;
      }
      if (values?.riskLocations?.riskSumInsured?.costOfConstruction) {
        //console.log('my validation')
        t = values?.riskLocations?.riskSumInsured?.costOfConstruction
        decimalcheck = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t;
        //console.log('decimalcheck op',decimalcheck)
        if (t !== decimalcheck) {
          errors.riskLocations.riskSumInsured = {};
          errors.riskLocations.riskSumInsured.costOfConstruction =
            '* decimal valid upto 2 places only';
          errorCount += 1;
        }
        round = Math.round(values?.riskLocations?.riskSumInsured?.costOfConstruction).toString()
        //console.log('round value',round)
        if (round.length > 6) {
          //console.log('after round')
          errors.riskLocations.riskSumInsured = {};
          errors.riskLocations.riskSumInsured.costOfConstruction =
            '* cannot exceed six digits';
          errorCount += 1;
        }
      }
    }
    if (fireQuote.basisOfValuation === 'Reinstatement value') {
      if (values?.riskLocations?.riskSumInsured?.carpetArea) {
        //console.log('my validation')
        t = values?.riskLocations?.riskSumInsured?.carpetArea
        decimalcheck = (t.indexOf(".") >= 0) ? (t.substr(0, t.indexOf(".")) + t.substr(t.indexOf("."), 3)) : t;
        //console.log('decimalcheck op',decimalcheck)
        if (t !== decimalcheck) {
          errors.riskLocations.riskSumInsured = {};
          errors.riskLocations.riskSumInsured.carpetArea =
            '* decimal valid upto 2 places only';
          errorCount += 1;
        }
        round = Math.round(values?.riskLocations?.riskSumInsured?.carpetArea).toString()
        //console.log('round value',round)
        if (round.length > 6) {
          errors.riskLocations.riskSumInsured = {};
          errors.riskLocations.riskSumInsured.carpetArea =
            '* cannot exceed six digits';
          errorCount += 1;
        }
      }
    }
    if (values?.riskLocations?.riskSumInsured?.additionalStructure) {
      t = Math.round(values?.riskLocations?.riskSumInsured?.additionalStructure).toString()
      if (t.length > 10) {
        errors.riskLocations.riskSumInsured = {};
        errors.riskLocations.riskSumInsured.additionalStructure =
          '* cannot exceed ten digits';
        errorCount += 1;
      }
    }
    if (fireQuote.basisOfValuation === 'Reinstatement value') {
      if (!values?.riskLocations?.riskSumInsured?.carpetArea) {
        if (!errors?.riskLocations?.riskSumInsured) {
          errors.riskLocations.riskSumInsured = {};
        }
        errors.riskLocations.riskSumInsured.carpetArea =
          '* Required';
        errorCount += 1;
      }
    }
    if (!values?.riskLocations?.riskSumInsured?.buildingValue) {
      if (!errors?.riskLocations?.riskSumInsured) {
        errors.riskLocations.riskSumInsured = {};
      }
      errors.riskLocations.riskSumInsured.buildingValue =
        '* Required';
      errorCount += 1;
    }
    //values?.riskLocations?.riskSumInsured
    //?.buildingValue riskLocations.riskSumInsured.totalBuildingSI
    if (!values?.riskLocations?.riskSumInsured?.totalBuildingSI) {
      if (!errors?.riskLocations?.riskSumInsured) {
        errors.riskLocations.riskSumInsured = {};
      }
      errors.riskLocations.riskSumInsured.totalBuildingSI =
        '* Required';
      errorCount += 1;
    }
    if (values?.riskLocations?.stock?.additionalContent
      ?.toString()
      ?.toLowerCase() === 'yes' && !values?.riskLocations?.stock?.additionalContentSI) {
      if (!errors?.riskLocations?.stock) {
        errors.riskLocations.stock = {};
      }
      errors.riskLocations.stock.additionalContentSI =
        '* Required';
      errorCount += 1;
    }
    if (values?.riskLocations?.stock?.additionalContent
      ?.toString()
      ?.toLowerCase() === 'yes' && !values?.riskLocations?.stock?.additionalContentSI) {
      if (!errors?.riskLocations?.stock) {
        errors.riskLocations.stock = {};
      }
      errors.riskLocations.stock.additionalContentSI =
        '* Required';
      errorCount += 1;
    }
    if (values?.riskLocations.stock.valuableContent
      ?.toString()
      ?.toLowerCase() === 'yes' && !values?.riskLocations.stock.valuableContentSI) {
      if (!errors?.riskLocations?.stock) {
        errors.riskLocations.stock = {};
      }
      errors.riskLocations.stock.valuableContentSI =
        '* Required';
      errorCount += 1;
    }
    for (let i = 0; i < values?.riskLocations?.length; i++) {
      errors.riskLocations.push({});
    }
    for (let i = 0; i < values?.riskLocations?.length; i++) {
      errors.riskLocations[i].stockLocations = values?.riskLocations[
        i
      ]?.stockLocations?.map((_) => {
        return {};
      });
      if (
        !values?.riskLocations[i]?.previousClaimDetails
          ?.claimExperience
      ) {
        errors.riskLocations[i].previousClaimDetails = {
          claimExperience: `* Required`,
        };
        errorCount += 1;
      }
      if (!values?.riskLocations[i]?.occupancy?.value) {
        errors.riskLocations[i].occupancy = {
          value: `* Required`,
        };
        errorCount += 1;
      }
      if (
        values?.riskLocations[i]?.occupancy?.value &&
        !getDomainData(
          PRD_occupancy,
          values?.riskLocations[i]?.occupancy?.value,
          'value',
          'code',
        )
      ) {
        errors.riskLocations[i].occupancy = {
          value: `* Choose an valid occupancy from the available list`,
        };
        errorCount += 1;
      }
      if (!values?.riskLocations[i]?.addressDetails?.addressLine1) {
        if (!errors?.riskLocations[i]?.addressDetails) {
          errors.riskLocations[i].addressDetails = {};
        }
        errors.riskLocations[i].addressDetails.addressLine1 =
          '* Required';
        errorCount += 1;
      }
      if (values?.riskLocations[i]?.addressDetails?.addressLine1.toString().length < 3 && values?.riskLocations[i]?.addressDetails?.addressLine1.toString().length >= 1) {
        if (!errors?.riskLocations[i]?.addressDetails) {
          errors.riskLocations[i].addressDetails = {};
        }
        errors.riskLocations[i].addressDetails.addressLine1 =
          'Minimum 3 characters required';
        errorCount += 1;
      }
      if (!values?.riskLocations[i]?.addressDetails?.pincode) {
        if (!errors?.riskLocations[i]?.addressDetails) {
          errors.riskLocations[i].addressDetails = {};
        }
        errors.riskLocations[i].addressDetails.pincode = '* Required';
        errorCount += 1;
      } else if (
        values?.riskLocations[i]?.addressDetails?.pincode &&
        (values?.riskLocations[i]?.addressDetails?.pincode?.length !==
          6 ||
          !values?.riskLocations[i]?.addressDetails?.pincode?.match(
            /^[0-9]+$/,
          ))
      ) {
        if (!errors?.riskLocations[i]?.addressDetails) {
          errors.riskLocations[i].addressDetails = {};
        }
        errors.riskLocations[i].addressDetails.pincode =
          '* Pincode must be of 6 digits';
        errorCount += 1;
      } else if (
        values?.riskLocations[i]?.addressDetails?.pincode &&
        values?.riskLocations[i]?.addressDetails?.pincode?.length ===
        6 &&
        (!values?.riskLocations[i]?.addressDetails?.state ||
          !values?.riskLocations[i]?.addressDetails?.district)
      ) {
        if (!errors?.riskLocations[i]?.addressDetails) {
          errors.riskLocations[i].addressDetails = {};
        }
        errors.riskLocations[i].addressDetails.pincode =
          '* Click the search icon to fetch city, district and state';
        errorCount += 1;
      }
      if (!values?.riskLocations[i]?.addressDetails?.state) {
        if (!errors?.riskLocations[i]?.addressDetails) {
          errors.riskLocations[i].addressDetails = {};
        }
        errors.riskLocations[i].addressDetails.state = '* Required';
        errorCount += 1;
      }
      if (!values?.riskLocations[i]?.addressDetails?.district) {
        if (!errors?.riskLocations[i]?.addressDetails) {
          errors.riskLocations[i].addressDetails = {};
        }
        errors.riskLocations[i].addressDetails.district =
          '* Required';
        errorCount += 1;
      }
      if (
        !values?.riskLocations[i]?.riskSumInsured?.buildingSI &&
        !values?.riskLocations[i]?.riskSumInsured
          ?.plantMachinerySI &&
        !values?.riskLocations[i]?.riskSumInsured
          ?.furnitureFixtureSI &&
        !values?.riskLocations[i]?.riskSumInsured?.rawMaterialSI &&
        !values?.riskLocations[i]?.riskSumInsured?.otherContentsSI &&
        !values?.riskLocations[i]?.stock?.stocksSI &&
        !values?.riskLocations[i]?.stock?.stocksInProcessSI
      ) {
        errors.riskLocations[
          i
        ].riskSumInsuredStocks = `* Atleast one field has to be filled in Risk Sum Insured section or Stock section`;
        errorCount += 1;
      }
      if (
        values?.riskLocations[i]?.stock?.stocksOnFloaterBasis
          ?.toString()
          ?.toLowerCase() === 'yes' &&
        !values?.riskLocations[i]?.stock?.maximumStockSIAtOneLocation
      ) {
        if (!errors?.riskLocations[i]?.stock) {
          errors.riskLocations[i].stock = {};
        }
        errors.riskLocations[i].stock.maximumStockSIAtOneLocation =
          '* Required';
        errorCount += 1;
      } else if (
        values?.riskLocations[i]?.stock?.stocksOnFloaterBasis
          ?.toString()
          ?.toLowerCase() === 'yes' &&
        values?.riskLocations[i]?.stock
          ?.maximumStockSIAtOneLocation &&
        parseInt(
          values?.riskLocations[i]?.stock
            ?.maximumStockSIAtOneLocation,
        ) <= 0
      ) {
        if (!errors?.riskLocations[i]?.stock) {
          errors.riskLocations[i].stock = {};
        }
        errors.riskLocations[i].stock.maximumStockSIAtOneLocation =
          '* Amount cannot be less than or equal to 0';
        errorCount += 1;
      } else if (
        values?.riskLocations[i]?.stock?.stocksOnFloaterBasis
          ?.toString()
          ?.toLowerCase() === 'yes' &&
        values?.riskLocations[i]?.stock
          ?.maximumStockSIAtOneLocation &&
        parseInt(
          values?.riskLocations[i]?.stock
            ?.maximumStockSIAtOneLocation,
        ) >
        parseInt(
          values?.riskLocations[i]?.stock?.stocksSI
            ? values?.riskLocations[i]?.stock?.stocksSI
            : '0',
        ) +
        parseInt(
          values?.riskLocations[i]?.stock?.stocksInProcessSI
            ? values?.riskLocations[i]?.stock?.stocksInProcessSI
            : '0',
        )
      ) {
        if (!errors?.riskLocations[i]?.stock) {
          errors.riskLocations[i].stock = {};
        }
        errors.riskLocations[i].stock.maximumStockSIAtOneLocation =
          '* Max Stock SI cannot be more than sum of stocks SI & stocks in process SI';
        errorCount += 1;
      }



      if (
        parseFloat(
          values?.loadingAndDiscount
            ?.loadingPercentage,
        ) > 100
      ) {
        errors.loadingAndDiscount = {
          ...errors.loadingAndDiscount,
          loadingPercentage: '* Percentage cannot be more than 100',
        };
      }
      if (
        parseFloat(
          values?.loadingAndDiscount
            ?.discountPercentage,
        ) > 100
      ) {
        errors.loadingAndDiscount = {
          ...errors.loadingAndDiscount,
          discountPercentage: '* Percentage cannot be more than 100',
        };
      }

    }
    if (errorCount === 0) {
      return {};
    }
    return errors;
  };

  const getSaveLocationVariables = (values, riskCovers, riskLocationIndex) => {
    let riskInput = [];
    //let riskInput = [];
    riskCovers?.forEach((r) => {
      // console.log("1039 ......r : ",r);
      let covers = [];

      r?.covers
        ?.filter(
          (c) => values[`addOnCovers`][c?.name]?.selected || c?.name === 'Basic Fire Cover',
        )
        ?.forEach((c) => {
          //  console.log("1-----",values[`riskLocations`][`addOnCovers`][c?.name]);
          const { selected, attributes, ...rest } = c;
          let attributesArr = [];
          c?.attributes?.forEach((attribute) => {
            attributesArr.push({
              ...attribute,
              value: attribute?.showOnScreen
                ? `${values[`addOnCovers`][`${c?.name}`][
                `attributes`
                ][`${attribute?.name}`]
                }`
                : `${attribute?.defaultValue}`,
            });
          });
          covers.push({
            ...rest,
            attributes: [...attributesArr],
          });
        });
      if (covers?.length !== 0) {
        riskInput.push({
          riskType: r?.riskType,
          covers,
        });
      }
    });
    return {
      input: {
        productCode: fireQuote?.productCode,
        productName: fireQuote?.productKg,
        quoteNumber: fireQuote?.quoteNumber
          ? fireQuote?.quoteNumber
          : '',
        riskLocationID:
          values?.riskLocations?.riskLocationID,
        occupancyCodeValue: {
          code: values?.riskLocations?.occupancy
            ?.code,
          value:
            values?.riskLocations?.occupancy
              ?.value,
          occupancySection:
            values?.riskLocations?.occupancy
              ?.occupancySection,
          occupancyRate:
            values?.riskLocations?.occupancy
              ?.occupancyRate,
          riskCode:
            values?.riskLocations?.occupancy
              ?.riskCode,
          rateCode:
            values?.riskLocations?.occupancy
              ?.rateCode,
          riskGrade:
            values?.riskLocations?.occupancy
              ?.riskGrade,
          riskGradeDefinition:
            values?.riskLocations?.occupancy
              ?.riskGradeDefinition,
          riskPreference:
            values?.riskLocations?.occupancy
              ?.riskPreference,
          gicClass:
            values?.riskLocations?.occupancy
              ?.gicClass,
          stfiRate:
            values?.riskLocations?.occupancy
              ?.stfiRate,
          rsmdRate:
            values?.riskLocations?.occupancy
              ?.rsmdRate,
        },
        riskLocAddress: {
          pinCode:
            values?.riskLocations?.addressDetails
              ?.pincode,
          state:
            values?.riskLocations?.addressDetails
              ?.state,
          city: values?.riskLocations
            ?.addressDetails?.city,
          district:
            values?.riskLocations?.addressDetails
              ?.district,
          // eqZone:
          //   values?.riskLocations[riskLocationIndex]?.addressDetails
          //     ?.eqZone,
          addressLine1:
            values?.riskLocations?.addressDetails
              ?.addressLine1,
          locationCode:
            values?.riskLocations?.addressDetails
              ?.locationCode,
          isSamePremises: values?.riskLocations
            ?.addressDetails?.isSamePremise
            ? true
            : false,
        },
        costOfConstruction:
          parseFloat(values?.riskLocations?.riskSumInsured
            ?.costOfConstruction),
        carpetArea:
          parseFloat(values?.riskLocations?.riskSumInsured
            ?.carpetArea),
        ratePerMille: riskCovers
          ?.find(
            (risk) => risk?.riskType === 'Cover Fire SA',
          )
          ?.covers?.map((cov) =>
            cov?.name === 'Basic Fire Cover'
              ? cov?.basicRate
              : 0,
          )
          // ?.filter((d: any) => d),
          ?.filter((d) => d)?.[0],
        buildingValue:
          parseFloat(values?.riskLocations?.riskSumInsured
            ?.buildingValue),
        additionalStructure:
          parseFloat(values?.riskLocations?.riskSumInsured
            ?.additionalStructure),
        totalBuildingSI:
          parseFloat(values?.riskLocations?.riskSumInsured
            ?.totalBuildingSI),
        generalContentSI:
          parseFloat(values?.riskLocations?.stock
            ?.generalContentSI),
        additionalContent:
          values?.riskLocations?.stock?.additionalContent,
        additionalContentSI:
          parseFloat(values?.riskLocations?.stock?.additionalContentSI),

        valuableContent:
          values?.riskLocations?.stock
            ?.valuableContent,
        valuableContentSI:
          parseFloat(values?.riskLocations?.stock
            ?.valuableContentSI),
        totalContentSI:
          parseFloat(values?.riskLocations?.stock
            ?.totalContentSI),
        totalSumInsured:
          parseFloat(values?.riskLocations?.stock
            ?.totalSumInsured),
        riskCovers: riskInput ? riskInput : [],
        loadingPct:
          values?.loadingAndDiscount?.loadingPercentage,
        discountPct:
          values?.loadingAndDiscount
            ?.discountPercentage,
        // prevClaimExpDesc:
        //   values?.riskLocations[riskLocationIndex]
        //     ?.previousClaimDetails?.claimExperience,
        premium: {
          locNetPremium: values?.riskLocations
            ?.locationPremium?.locationNetPremium
            ? `${values?.riskLocations?.locationPremium?.locationNetPremium}`
            : '',
          locGST: values?.riskLocations
            ?.locationPremium?.locationGST
            ? `${values?.riskLocations?.locationPremium?.locationGST}`
            : '',
          locTotalPremium: values?.riskLocations
            ?.locationPremium?.locationTotalPremium
            ? `${values?.riskLocations?.locationPremium?.locationTotalPremium}`
            : '',
        },
      },
    };
  };

  const onSubmit = (values) => {
    updateFireQuote({
      ...values,
    });
    return true;
  };

  const getDomainData = (
    domainArr,
    searchText,
    searchType,
    returnType,
  ) => {
    return domainArr.find((d) => d[`${searchType}`] === searchText)
      ? domainArr.find((d) => d[`${searchType}`] === searchText)[
      `${returnType}`
      ]
      : '';
  };

  const RiskLocationForm = ({

    // initStockLocationObj,
    validate,
    setAddOrProceedDisabled,
    setChangeDisabled,
    riskCovers,
  }) => {
    const { values, setFieldValue, errors } =
      useQuantaFormikContext();
    const [alerts, setAlerts] = useState([]);
    const [loadingPermCustAddr, setLoadingPermCustAddr] =
      useState(false);
    const [loadingPremium, setLoadingPremium] = useState(false);
    const [errorPremium, setErrorPremium] = useState(null);
    const [warningMsg, setWarningMsg] = useState(null);
    const [premiumData, setPremiumData] = useState(
      initialValues?.riskLocations
        ?.locationPremium,
    );
    const [isSavingLocation, setSavingLocation] = useState(false);
    const [isSaveDisabled, setSaveDisabled] = useState(false);
    const [isCalculateDisabled, setIsCalculateDisabled] =
      useState(false);
    const [errorSavingLocation, setErrorSavingLocation] =
      useState(null);
    const [showStockLocationModal, setShowStockLocationModal] =
      useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showViewBreakup, setShowViewBreakup] = useState(false);
    const [
      showCalculatePremiumButton,
      setShowCalculatePremiumButton,
    ] = useState(false);
    // Additional Content and Valuable Content 
    useEffect(() => {
      if (fireQuote?.status
        ?.toString()
        ?.toLowerCase() ===
        'quote draft') {
        if (!values?.riskLocations?.stock?.additionalContent) {
          setFieldValue(
            `riskLocations.stock.additionalContent`,
            `No`,
          );
        }
        if (!values?.riskLocations?.stock?.valuableContent) {
          setFieldValue(
            `riskLocations.stock.valuableContent`,
            `No`,
          );
        }
      }
    }, [])
    // Additional Content and Valuable Content
    //Discount and Loading
    useEffect(() => {
      if (values?.loadingAndDiscount?.discountPercentage == '' && values?.loadingAndDiscount?.discountPercentage <= 0) {
        setFieldValue(
          `loadingAndDiscount.discountPercentage`,
          `0`,
        );
      }
      if (values?.loadingAndDiscount?.loadingPercentage == '' && values?.loadingAndDiscount?.loadingPercentage <= 0) {
        setFieldValue(
          `loadingAndDiscount.loadingPercentage`,
          `0`,
        );
      }
    }, [])
    //Discount


    //   useEffect(() => {
    //     setFieldValue(
    //     `riskLocations.riskSumInsured.costOfConstruction`,
    //     fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.geographicalArea
    //         ? PRD_costOfConstruction?.defaultValue

    //        : '',
    //   )
    //  },
    //  [
    //   fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.geographicalArea
    // ])
    useEffect(() => {
      if (fireQuote?.riskcoverdata?.length !== 0) {
        setFieldValue(
          `riskLocations.riskSumInsured.costOfConstruction`,
          fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.costOfConstruction
        )
      }
      else {
        setFieldValue(
          `riskLocations.riskSumInsured.costOfConstruction`,
          fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.geographicalArea
            ? PRD_costOfConstruction?.defaultValue
            : '',
        )
      }
    },
      [
        fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.geographicalArea
      ])
    useEffect(() => {
      // console.log("dwelling",fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value)
      setFieldValue(
        `riskLocations.occupancy.value`,
        fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
          ?.toString()
          ?.toLowerCase() === 'dwelling' &&
          PRD_occupancy &&
          PRD_occupancy?.length > 0
          ? PRD_occupancy[0]?.value
            ? `${PRD_occupancy[0]?.value}`
            : ''
          : PRD_occupancy[1]?.value
            ? `${PRD_occupancy[1]?.value}`
            : '',
      );
      setFieldValue(
        `riskLocations.occupancy.code`,

        fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
          ?.toString()
          ?.toLowerCase() === 'dwelling' &&
          PRD_occupancy &&
          PRD_occupancy?.length > 0 ?
          PRD_occupancy[0]?.code
            ? `${PRD_occupancy[0]?.code}`
            : ''
          : PRD_occupancy[1]?.code
            ? `${PRD_occupancy[1]?.code}`
            : '',
      );
      setFieldValue(
        `riskLocations.occupancy.occupancySection`,
        fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
          ?.toString()
          ?.toLowerCase() === 'dwelling' &&
          PRD_occupancy &&
          PRD_occupancy?.length > 0 ?
          PRD_occupancy[0]?.occupancySection
            ? `${PRD_occupancy[0]?.occupancySection}`
            : ''
          : PRD_occupancy[1]?.occupancySection
            ? `${PRD_occupancy[1]?.occupancySection}`
            : '',
      );
      setFieldValue(
        `riskLocations.occupancy.occupancyRate`,
        fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
          ?.toString()
          ?.toLowerCase() === 'dwelling' &&
          PRD_occupancy &&
          PRD_occupancy?.length > 0 ?
          PRD_occupancy[0]?.occupancyRate
            ? `${PRD_occupancy[0]?.occupancyRate}`
            : ''
          : PRD_occupancy[1]?.occupancyRate
            ? `${PRD_occupancy[1]?.occupancyRate}`
            : '',
      );
      setFieldValue(
        `riskLocations.occupancy.riskCode`,
        fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
          ?.toString()
          ?.toLowerCase() === 'dwelling' &&
          PRD_occupancy &&
          PRD_occupancy?.length > 0 ?
          PRD_occupancy[0]?.riskCode
            ? `${PRD_occupancy[0]?.riskCode}`
            : ''
          : PRD_occupancy[1]?.riskCode
            ? `${PRD_occupancy[1]?.riskCode}`
            : '',
      );
      setFieldValue(
        `riskLocations.occupancy.rateCode`,
        fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
          ?.toString()
          ?.toLowerCase() === 'dwelling' &&
          PRD_occupancy &&
          PRD_occupancy?.length > 0 ?
          PRD_occupancy[0]?.rateCode
            ? `${PRD_occupancy[0]?.rateCode}`
            : ''
          : PRD_occupancy[1]?.rateCode
            ? `${PRD_occupancy[1]?.rateCode}`
            : '',
      );
      setFieldValue(
        `riskLocations.occupancy.rateCode`,
        fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
          ?.toString()
          ?.toLowerCase() === 'dwelling' &&
          PRD_occupancy &&
          PRD_occupancy?.length > 0 ?
          PRD_occupancy[0]?.rateCode
            ? `${PRD_occupancy[0]?.rateCode}`
            : ''
          : PRD_occupancy[1]?.rateCode
            ? `${PRD_occupancy[1]?.rateCode}`
            : '',
      );
      setFieldValue(
        `riskLocations.occupancy.riskGrade`,
        fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
          ?.toString()
          ?.toLowerCase() === 'dwelling' &&
          PRD_occupancy &&
          PRD_occupancy?.length > 0 ?
          PRD_occupancy[0]?.riskGrade
            ? `${PRD_occupancy[0]?.riskGrade}`
            : ''
          : PRD_occupancy[1]?.riskGrade
            ? `${PRD_occupancy[1]?.riskGrade}`
            : '',
      );
      setFieldValue(
        `riskLocations.occupancy.riskGradeDefinition`,
        fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
          ?.toString()
          ?.toLowerCase() === 'dwelling' &&
          PRD_occupancy &&
          PRD_occupancy?.length > 0 ?
          PRD_occupancy[0]?.riskGradeDefinition
            ? `${PRD_occupancy[0]?.riskGradeDefinition}`
            : ''
          : PRD_occupancy[1]?.riskGradeDefinition
            ? `${PRD_occupancy[1]?.riskGradeDefinition}`
            : '',
      );
      setFieldValue(
        `riskLocations.occupancy.riskPreference`,
        fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
          ?.toString()
          ?.toLowerCase() === 'dwelling' &&
          PRD_occupancy &&
          PRD_occupancy?.length > 0 ?
          PRD_occupancy[0]?.riskPreference
            ? `${PRD_occupancy[0]?.riskPreference}`
            : ''
          : PRD_occupancy[1]?.riskPreference
            ? `${PRD_occupancy[1]?.riskPreference}`
            : '',
      );
      setFieldValue(
        `riskLocations.occupancy.gicClass`,
        fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
          ?.toString()
          ?.toLowerCase() === 'dwelling' &&
          PRD_occupancy &&
          PRD_occupancy?.length > 0 ?
          PRD_occupancy[0]?.gicClass
            ? `${PRD_occupancy[0]?.gicClass}`
            : ''
          : PRD_occupancy[1]?.gicClass
            ? `${PRD_occupancy[1]?.gicClass}`
            : '',
      );
      setFieldValue(
        `riskLocations.occupancy.stfiRate`,
        fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
          ?.toString()
          ?.toLowerCase() === 'dwelling' &&
          PRD_occupancy &&
          PRD_occupancy?.length > 0 ?
          PRD_occupancy[0]?.stfiRate
            ? `${PRD_occupancy[0]?.stfiRate}`
            : ''
          : PRD_occupancy[1]?.stfiRate
            ? `${PRD_occupancy[1]?.stfiRate}`
            : '',
      );
      setFieldValue(
        `riskLocations.occupancy.stfiRate`,
        fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value
          ?.toString()
          ?.toLowerCase() === 'dwelling' &&
          PRD_occupancy &&
          PRD_occupancy?.length > 0 ?
          PRD_occupancy[0]?.rsmdRate
            ? `${PRD_occupancy[0]?.rsmdRate}`
            : ''
          : PRD_occupancy[1]?.rsmdRate
            ? `${PRD_occupancy[1]?.rsmdRate}`
            : '',
      );

    }, [
      fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType,
    ]);
    useEffect(() => {

      if (
        !isNaN(parseFloat(values?.riskLocations?.riskSumInsured?.buildingValue)) &&
        !isNaN(parseFloat(values?.riskLocations?.riskSumInsured?.additionalStructure))
      ) {
        setFieldValue(
          `riskLocations.riskSumInsured.totalBuildingSI`,
          `${parseFloat(values?.riskLocations?.riskSumInsured?.buildingValue) +
          parseFloat(
            values?.riskLocations?.riskSumInsured?.additionalStructure,
          )
          }`,
        );
      }
      else if (

        !isNaN(
          parseFloat(
            values?.riskLocations?.riskSumInsured?.buildingValue,
          ),
        )
      ) {
        setFieldValue(
          `riskLocations.riskSumInsured.totalBuildingSI`,
          values?.riskLocations?.riskSumInsured?.buildingValue,

        );
      }
      else if (

        !isNaN(
          parseFloat(
            values?.riskLocations?.riskSumInsured?.additionalStructure,
          ),
        )
      ) {
        setFieldValue(
          `riskLocations.riskSumInsured.totalBuildingSI`,
          values?.riskLocations?.riskSumInsured?.additionalStructure,

        );
      }
      else {

        setFieldValue(
          `riskLocations.riskSumInsured.totalBuildingSI`,
          '',

        );
      }

    }, [
      values?.riskLocations?.riskSumInsured?.buildingValue,
      values?.riskLocations?.riskSumInsured?.additionalStructure,

    ]);
    const gcs1i = () => {

      if (

        !isNaN(
          parseFloat(
            values?.riskLocations?.riskSumInsured?.totalBuildingSI,
          ),
        ) &&
        (parseFloat(
          values?.riskLocations?.riskSumInsured?.totalBuildingSI,
        ) * 0.2) > 1000000
      ) {
        setFieldValue(
          `riskLocations.stock.generalContentSI`,
          '1000000'

        );
        return (parseFloat(1000000))
      }
      else if (!isNaN(
        parseFloat(
          values?.riskLocations?.riskSumInsured?.totalBuildingSI,
        ),
      )) {
        let GenConSI = parseFloat(values?.riskLocations?.riskSumInsured?.totalBuildingSI) * 0.2;
        setFieldValue(
          `riskLocations.stock.generalContentSI`,
          GenConSI,

        );
        setFieldValue(
          `riskLocations.stock.totalContentSI`,
          GenConSI,
        );

      }
      //console.log('inside gcsi',values?.riskLocations?.riskSumInsured?.totalBuildingSI * 0.2)
      return (parseFloat(values?.riskLocations?.riskSumInsured?.totalBuildingSI) * 0.2)

    }
    useEffect(() => {


      if (
        !isNaN(parseFloat(values?.riskLocations?.riskSumInsured?.totalBuildingSI)) &&
        !isNaN(parseFloat(values?.riskLocations?.stock?.totalContentSI))
      ) {
        setFieldValue(
          `riskLocations.stock.totalSumInsured`,
          `${parseFloat(values?.riskLocations?.riskSumInsured?.totalBuildingSI) +
          parseFloat(
            values?.riskLocations?.stock?.totalContentSI,
          )
          }`,
        );
      }
      else if (fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value.toString()
        === 'Home Building And Home Contents'
      ) {
        if (
          !isNaN(
            parseFloat(
              values?.riskLocations?.riskSumInsured?.totalBuildingSI,
            ),
          ) && isNaN(parseFloat(values?.riskLocations?.stock?.totalContentSI))
        ) {
          setFieldValue(
            `riskLocations.stock.totalSumInsured`,
            `${parseFloat(values?.riskLocations?.riskSumInsured?.totalBuildingSI) +
            gcs1i()}`
          );
        }
      }
      else if (

        !isNaN(
          parseFloat(
            values?.riskLocations?.riskSumInsured?.totalBuildingSI,
          ),
        )
      ) {
        setFieldValue(
          `riskLocations.stock.totalSumInsured`,
          values?.riskLocations?.riskSumInsured?.totalBuildingSI,

        );
      }
      else if (

        !isNaN(
          parseFloat(
            values?.riskLocations?.stock?.totalContentSI,
          ),
        )
      ) {
        setFieldValue(
          `riskLocations.stock.totalSumInsured`,
          values?.riskLocations?.stock?.totalContentSI,

        );
      }
      // else {
      //   setFieldValue(
      //     `riskLocations.stock.totalContentSI`,
      //     '',
      //   );
      // }

    }, [
      values?.riskLocations?.riskSumInsured?.totalBuildingSI,
      values?.riskLocations?.stock?.totalContentSI,

    ]);

    //general
    useEffect(() => {


      if (

        !isNaN(
          parseFloat(
            values?.riskLocations?.riskSumInsured?.totalBuildingSI,
          ),
        ) &&
        (parseFloat(
          values?.riskLocations?.riskSumInsured?.totalBuildingSI,
        ) * 0.2) > 1000000
      ) {
        setFieldValue(
          `riskLocations.stock.generalContentSI`,
          '1000000'

        );
      }
      else {
        let GenConSI = parseFloat(values?.riskLocations?.riskSumInsured?.totalBuildingSI) * 0.2;

        setFieldValue(
          `riskLocations.stock.generalContentSI`,
          //values?.riskLocations?.riskSumInsured?.totalBuildingSI * 0.2,
          GenConSI,
        );
        setFieldValue(
          `riskLocations.stock.totalContentSI`,
          GenConSI,
        );


      }
    }, [
      values?.riskLocations?.riskSumInsured?.totalBuildingSI,
      // values?.riskLocations?.stock?.totalContentSI,

    ]);
    //new
    useEffect(() => {
      if (
        !isNaN(
          parseFloat(
            values?.riskLocations?.stock?.generalContentSI,
          ),
        ) &&
        !isNaN(
          parseFloat(
            values?.riskLocations?.stock?.valuableContentSI,
          ),
        ) && !isNaN(
          parseFloat(
            values?.riskLocations?.stock?.additionalContentSI,
          ),
        )
      ) {
        setFieldValue(
          `riskLocations.stock.totalContentSI`,
          `${parseFloat(
            values?.riskLocations?.stock?.generalContentSI,
          ) +
          parseFloat(
            values?.riskLocations?.stock?.valuableContentSI,
          ) +
          parseFloat(
            values?.riskLocations?.stock?.additionalContentSI,
          )
          }`,
        );
      } else if (
        !isNaN(
          parseFloat(
            values?.riskLocations?.stock?.generalContentSI,
          ),
        ) && !isNaN(
          parseFloat(
            values?.riskLocations?.stock?.additionalContentSI,
          ),
        )
      ) {
        setFieldValue(
          `riskLocations.stock.totalContentSI`,
          `${parseFloat(
            values?.riskLocations?.stock?.generalContentSI,
          ) +
          parseFloat(
            values?.riskLocations?.stock?.additionalContentSI,
          )
          }`,
        );
      } else if (
        !isNaN(
          parseFloat(
            values?.riskLocations?.stock?.generalContentSI,
          ),
        ) &&
        !isNaN(
          parseFloat(
            values?.riskLocations?.stock?.valuableContentSI,
          ),
        )
      ) {
        setFieldValue(
          `riskLocations.stock.totalContentSI`,
          `${parseFloat(
            values?.riskLocations?.stock?.generalContentSI,
          ) +
          parseFloat(
            values?.riskLocations?.stock?.valuableContentSI,
          )
          }`,
        );
      } else if (
        !isNaN(
          parseFloat(
            values?.riskLocations?.stock?.generalContentSI,
          ),
        )
      ) {
        setFieldValue(
          `riskLocations.stock.totalContentSI`,
          `${parseFloat(
            values?.riskLocations?.stock?.generalContentSI,
          )
          }`,
        );
      }
    },
      [
        values?.riskLocations?.stock?.generalContentSI,
        values?.riskLocations?.stock?.additionalContentSI,
        values?.riskLocations?.stock?.valuableContentSI,
      ]);
    //attribute
    useEffect(() => {

      if (values?.addOnCovers["Loss of Rent"]?.selected === true) {

        let lossOfRentSI = values?.addOnCovers["Loss of Rent"].attributes.lossOfRentSI;

        setFieldValue(
          `addOnCovers.Terrorism Damage Cover.attributes.terrorismDamageCoverSI`,
          `${parseFloat(values?.riskLocations?.stock?.totalSumInsured)
          +
          parseFloat(
            lossOfRentSI
          )
          }`,
        );
      }
      else if (values?.addOnCovers["Rent for an Alternative Accommodation"]?.selected === true) {
        let rentForAlternativeAccommodationSI = values?.addOnCovers["Rent for an Alternative Accommodation"]?.attributes?.rentForAlternativeAccommodationSI;
        setFieldValue(
          `addOnCovers.Terrorism Damage Cover.attributes.terrorismDamageCoverSI`,
          `${parseFloat(values?.riskLocations?.stock?.totalSumInsured)
          +
          parseFloat(
            rentForAlternativeAccommodationSI
          )
          }`,
        );
      }
      else {
        setFieldValue(
          `addOnCovers.${'Terrorism Damage Cover'}.attributes.${'terrorismDamageCoverSI'}`,

          values?.riskLocations?.stock?.totalSumInsured
        );
      }
      if (values?.addOnCovers["Loss of Rent"]?.selected === true) {
        let lossOfRentSI = values?.addOnCovers["Loss of Rent"].attributes.lossOfRentSI;
        setFieldValue(
          `addOnCovers.Earthquake Fire and Shock.attributes.earthquakeFireAndShockSI`,
          `${parseFloat(values?.riskLocations?.stock?.totalSumInsured)
          +
          parseFloat(
            lossOfRentSI
          )
          }`,
        );
      }
      else if (values?.addOnCovers["Rent for an Alternative Accommodation"]?.selected === true) {
        let rentForAlternativeAccommodationSI = values?.addOnCovers["Rent for an Alternative Accommodation"]?.attributes?.rentForAlternativeAccommodationSI;
        setFieldValue(
          `addOnCovers.Earthquake Fire and Shock.attributes.earthquakeFireAndShockSI`,
          `${parseFloat(values?.riskLocations?.stock?.totalSumInsured)
          +
          parseFloat(
            rentForAlternativeAccommodationSI
          )
          }`,
        );
      }
      else {
        setFieldValue(
          `addOnCovers.${'Earthquake Fire and Shock'}.attributes.${'earthquakeFireAndShockSI'}`,
          values?.riskLocations?.stock?.totalSumInsured
        );
      }

      setFieldValue(
        `addOnCovers.${'Riot, Strikes, Malicious Damages'}.attributes.${'riotsStrikesSI'
        }`,
        values?.riskLocations?.stock?.totalSumInsured
      );
      setFieldValue(
        `addOnCovers.${'STFI'}.attributes.${'stfiSI'
        }`,
        values?.riskLocations?.stock?.totalSumInsured
      );
    },
      [values?.riskLocations?.stock?.totalSumInsured,]
    );

    const getFireQuoteCalcPremiumVariables = (
      selectedIntermediary,
      //riskLocationIndex,
      // riskInput
    ) => {

      // console.log("1034 : values: ",values);
      // console.log("riskcovers :",riskCovers);
      try {
        let riskInput = [];
        riskCovers?.forEach((r) => {
          // console.log("1039 ......r : ",r);
          let covers = [];

          r?.covers
            ?.filter(
              (c) => values?.addOnCovers[c?.name]?.selected || c?.name === 'Basic Fire Cover',
            )
            ?.forEach((c) => {
              //  console.log("1-----",values[`riskLocations`][`addOnCovers`][c?.name]);
              const { selected, attributes, ...rest } = c;
              let attributesArr = [];
              c?.attributes?.forEach((attribute) => {
                attributesArr.push({
                  ...attribute,
                  value: attribute?.showOnScreen
                    ? `${values[`addOnCovers`][`${c?.name}`][
                    `attributes`
                    ][`${attribute?.name}`]
                    }`
                    : `${attribute?.defaultValue}`,
                });
              });
              covers?.push({
                ...rest,
                attributes: [...attributesArr],
              });
            });
          if (covers?.length !== 0) {
            riskInput?.push({
              riskType: r?.riskType,
              covers,
            });
          }
        });
        // console.log("riskInput",riskInput);
        return {
          input: {
            eqZone: fireQuote?.eqZone,
            locationCode: fireQuote?.locationCode,
            pinCodeLocality: fireQuote?.pinCodeLocality,
            city: fireQuote?.city,
            FireCustomerType: fireQuote?.tabDetails?.customerTabDetails?.customerDetails?.customerType?.value,
            intermediary: {
              intermediaryCode: fireQuote?.intermediaryDetails?.code
                ? fireQuote?.intermediaryDetails?.code
                : selectedIntermediary?.intermediaryCode,
              locationCode: selectedIntermediary?.branchOfficeCode
                ? `${selectedIntermediary?.branchOfficeCode}`
                : '',
              fieldUserCode: selectedIntermediary?.fieldUserCode
                ? `${selectedIntermediary?.fieldUserCode}`
                : '',
            },
            riskLocations: {
              quoteNumber: fireQuote?.quoteNumber,
              riskLocationID:
                values?.riskLocations
                  ?.riskLocationID,
              occupancyCodeValue: {
                code: values?.riskLocations
                  ?.occupancy?.code,
                value:
                  values?.riskLocations?.occupancy
                    ?.value,
                occupancySection:
                  values?.riskLocations?.occupancy
                    ?.occupancySection,
                occupancyRate:
                  values?.riskLocations?.occupancy
                    ?.occupancyRate,
                riskCode:
                  values?.riskLocations?.occupancy
                    ?.riskCode,
                rateCode:
                  values?.riskLocations?.occupancy
                    ?.rateCode,
                riskGrade:
                  values?.riskLocations?.occupancy
                    ?.riskGrade,
                riskGradeDefinition:
                  values?.riskLocations?.occupancy
                    ?.riskGradeDefinition,
                riskPreference:
                  values?.riskLocations?.occupancy
                    ?.riskPreference,
                gicClass:
                  values?.riskLocations?.occupancy
                    ?.gicClass,
                stfiRate:
                  values?.riskLocations?.occupancy
                    ?.stfiRate,
                rsmdRate:
                  values?.riskLocations?.occupancy
                    ?.rsmdRate,
              },
              riskLocAddress: {
                pinCode:
                  values?.riskLocations
                    ?.addressDetails?.pincode,
                state:
                  values?.riskLocations
                    ?.addressDetails?.state,
                city: values?.riskLocations
                  ?.addressDetails?.city,
                district:
                  values?.riskLocations
                    ?.addressDetails?.district,
                // eqZone:
                //   values?.riskLocations
                //     ?.addressDetails?.eqZone,
                addressLine1:
                  values?.riskLocations
                    ?.addressDetails?.addressLine1,
                locationCode:
                  values?.riskLocations
                    ?.addressDetails?.locationCode,
              },
              costOfConstruction:
                parseFloat(values?.riskLocations?.riskSumInsured
                  ?.costOfConstruction),
              carpetArea:
                parseFloat(values?.riskLocations?.riskSumInsured
                  ?.carpetArea),
              buildingValue:
                parseFloat(values?.riskLocations?.riskSumInsured
                  ?.buildingValue),
              ratePerMille: riskCovers
                ?.find(
                  (risk) => risk?.riskType === 'Cover Fire SA',
                )
                ?.covers?.map((cov) =>
                  cov?.name === 'Basic Fire Cover'
                    ? cov?.basicRate
                    : 0,
                )
                // ?.filter((d: any) => d),
                ?.filter((d) => d)?.[0],
              additionalStructure:
                parseFloat(values?.riskLocations?.riskSumInsured
                  ?.additionalStructure),
              totalBuildingSI:
                parseFloat(values?.riskLocations?.riskSumInsured
                  ?.totalBuildingSI),
              generalContentSI:
                parseFloat(values?.riskLocations?.stock
                  ?.generalContentSI),
              additionalContent:
                values?.riskLocations?.stock?.additionalContent,
              additionalContentSI:
                parseFloat(values?.riskLocations?.stock?.additionalContentSI),
              valuableContent:
                values?.riskLocations?.stock
                  ?.valuableContent,
              valuableContentSI:
                parseFloat(values?.riskLocations?.stock
                  ?.valuableContentSI),
              totalContentSI:
                parseFloat(values?.riskLocations?.stock
                  ?.totalContentSI),
              totalSumInsured:
                parseFloat(values?.riskLocations?.stock
                  ?.totalSumInsured),

              riskCovers: riskInput ? riskInput : [],
              loadingPct:
                values?.loadingAndDiscount?.loadingPercentage,
              discountPct:
                values?.loadingAndDiscount?.discountPercentage,

            },

            policyStartDate:
              fireQuote?.tabDetails?.customerTabDetails
                ?.policyTypeDetails?.policyStartDate,
            tenure:
              fireQuote?.tabDetails?.customerTabDetails
                ?.policyTypeDetails?.tenure?.code,
            policyType:
              fireQuote?.tabDetails?.customerTabDetails
                ?.policyTypeDetails?.policyOrCoverType?.code,
            coverType:
              fireQuote?.tabDetails?.customerTabDetails
                ?.policyTypeDetails?.policyOrCoverType?.code,
            basisOfValuation: fireQuote?.basisOfValuation,
            subProductName: fireQuote?.productKg || fireQuote?.productName,//"Kotak Bharat Griha Raksha",//drop //
            riskType: fireQuote?.customerDetails?.customerType?.value,//'Dwelling', 
            geographicalArea:
              fireQuote?.tabDetails?.customerTabDetails
                ?.policyTypeDetails?.geographicalArea?.code,

            productCode: fireQuote?.productCode,
            productName: fireQuote?.productKg,
            enddate: moment()
              .add(parseInt(fireQuote?.tabDetails?.customerTabDetails
                ?.policyTypeDetails?.tenure?.code), 'years').add(-1, 'days')
              .format('DD/MM/YYYY'),
          },
        };
      } catch (error) {
        //// console.log(error)
      }
    };
    const onPermAddrLookup = async (val, setFieldValue) => {
      if (val?.length === 6 && val?.match(/^[0-9]+$/)) {
        try {
          let queryOutput = fetchQuery({
            query: PINCODE_LOOKUP,
            variables: {
              filter: {
                pincode: val,
              },
            },
          });
          setAlerts([]);
          setLoadingPermCustAddr(true);
          setChangeDisabled(true);
          let { data } = await queryOutput;
          setLoadingPermCustAddr(false);
          setChangeDisabled(false);
          if (!data?.pincodeWithEqZone) {
            setAlerts([
              {
                header: 'Address fetch failed',
                id: parseInt(uuidv4()),
                content: (
                  <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                    <span>{'Invalid Pincode'}</span>
                  </div>
                ),
                type: 'error',
                timeout: null,
                disableClose: false,
              },
            ]);
            setFieldValue(
              `riskLocations.addressDetails.state`,
              '',
            );
            setFieldValue(
              `riskLocations.addressDetails.district`,
              '',
            );
            // setFieldValue(
            //   `riskLocations.stockLocations[0].state`,
            //   '',
            // );
            // setFieldValue(
            //   `riskLocations.stockLocations[0].district`,
            //   '',
            // );
            // setFieldValue(
            //   `riskLocations.stockLocations[0].eqZone`,
            //   '',
            // );
            // setFieldValue(
            //   `riskLocations.stockLocations[0].locationCode`,
            //   '',
            // );
            // setFieldValue(
            //   `riskLocations.stockLocations[0].locationDesc`,
            //   '',
            // );
            window?.scrollTo({ top: 0, behavior: 'smooth' });
          } else {
            setFieldValue(
              `riskLocations.addressDetails.state`,
              data?.pincodeWithEqZone?.state
                ? `${data?.pincodeWithEqZone?.state}`
                : '',
            );
            setFieldValue(
              `riskLocations.addressDetails.district`,
              data?.pincodeWithEqZone?.district
                ? `${data?.pincodeWithEqZone?.district}`
                : '',
            );
            // setFieldValue(
            //   `riskLocations.addressDetails.eqZone`,
            //   data?.pincodeWithEqZone?.eqZone
            //     ? `${data?.pincodeWithEqZone?.eqZone}`
            //     : '',
            // );
            // setFieldValue(
            //   `riskLocations.addressDetails.locationCode`,
            //   data?.pincodeWithEqZone?.locationCode
            //     ? `${data?.pincodeWithEqZone?.locationCode}`
            //     : '',
            // );
            // setFieldValue(
            //   `riskLocations.addressDetails.locationDesc`,
            //   data?.pincodeWithEqZone?.locationDesc
            //     ? `${data?.pincodeWithEqZone?.locationDesc}`
            //     : '',
            // );
            // setFieldValue(
            //   `riskLocations.stockLocations[0].state`,
            //   data?.pincodeWithEqZone?.state
            //     ? `${data?.pincodeWithEqZone?.state}`
            //     : '',
            // );
            // setFieldValue(
            //   `riskLocations.stockLocations[0].district`,
            //   data?.pincodeWithEqZone?.district
            //     ? `${data?.pincodeWithEqZone?.district}`
            //     : '',
            // );
            // setFieldValue(
            //   `riskLocations[${riskLocationIndex}].stockLocations[0].eqZone`,
            //   data?.pincodeWithEqZone?.eqZone
            //     ? `${data?.pincodeWithEqZone?.eqZone}`
            //     : '',
            // );
            // setFieldValue(
            //   `riskLocations.stockLocations[0].locationCode`,
            //   data?.pincodeWithEqZone?.locationCode
            //     ? `${data?.pincodeWithEqZone?.locationCode}`
            //     : '',
            // );
            // setFieldValue(
            //   `riskLocations.stockLocations[0].locationDesc`,
            //   data?.pincodeWithEqZone?.locationDesc
            //     ? `${data?.pincodeWithEqZone?.locationDesc}`
            //     : '',
            // );
          }
        } catch (error) {
          setAlerts([
            {
              header: 'Address fetch failed',
              id: parseInt(uuidv4()),
              content: (
                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                  <span>{error.message}</span>
                </div>
              ),
              type: 'error',
              timeout: null,
              disableClose: false,
            },
          ]);
          setLoadingPermCustAddr(false);
          setChangeDisabled(false);
          setFieldValue(
            `riskLocations.addressDetails.state`,
            '',
          );
          setFieldValue(
            `riskLocations.addressDetails.district`,
            '',
          );
          // setFieldValue(
          //   `riskLocations.stockLocations[0].state`,
          //   '',
          // );
          // setFieldValue(
          //   `riskLocations.stockLocations[0].district`,
          //   '',
          // );
          // setFieldValue(
          //   `riskLocations.stockLocations[0].eqZone`,
          //   '',
          // );
          // setFieldValue(
          //   `riskLocations.stockLocations[0].locationCode`,
          //   '',
          // );
          // setFieldValue(
          //   `riskLocations.stockLocations[0].locationDesc`,
          //   '',
          // );
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      }
    };
    const cov = (coverName, attribute) => {
      let returnval = 0
      let x = coverlimiter()
      const y = newfunction(x, coverName)
      //return(parseInt(777))
      if ((values?.riskLocations?.riskSumInsured?.totalBuildingSI && y)
        && (
          //coverName.toString() === 'Additional Living Expenses' ||
          // coverName.toString() === 'Involuntary Betterment Technological Advancement' ||
          coverName.toString() === 'Loss Minimization Expenses' ||
          coverName.toString() === 'Specified Incidental Expenses Cover'
        )) {

        //return(
        returnval = (parseInt(values?.riskLocations?.riskSumInsured?.totalBuildingSI) *
          parseInt(y)) / 100
        // setFieldValue(
        //   [`addOnCovers`][`${coverName}`][
        //     `attributes`
        //   ][`${attribute?.name}`],
        //   returnval,
        // );
        values[`addOnCovers`][`${coverName}`][
          `attributes`
        ][`${attribute?.name}`] = returnval
        //  ))
      } else {

        returnval = values[`addOnCovers`][`${coverName}`][
          `attributes`
        ][`${attribute?.name}`]

      }
      return returnval


    }
    const attributeData = (attributes, coverName) => {
      return attributes
        ? attributes
          ?.filter((attr) => attr.showOnScreen)
          ?.map((attribute) => {
            return attribute?.fieldDataType === 'amount'
              ? {
                type: `${attribute.fieldType}`,
                label: (
                  <Text type={'label'}>
                    {attribute.displayName}{' '}

                    <Text severity="error">{(attribute?.name !== 'Terrorism Third Party Liability' && attribute?.name !== 'Terrorism Political Violence') ? '*' : ''}</Text>
                  </Text>
                ),
                name: `addOnCovers.${coverName}.attributes.${attribute.name}`,
                disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' ||
                  loadingPremium ||
                  values?.isQuoteSaved ||
                  values?.isQuoteSaving ||
                  attribute.name === 'earthquakeFireAndShockSI' ||
                  attribute.name === 'stfiSI' ||
                  attribute.name === 'riotsStrikesSI' ||
                  attribute.name === 'terrorismDamageCoverSI' ||
                  //     (attribute.name==='terrorismDamageCoverSI' && fireQuote?.productKg?.toString() =='Kotak Bharat Griha Raksha') ||
                  attribute.name === 'personalAccidentCoverSelfSI' ||
                  attribute.name === 'personalAccidentCoverSpouseSI' ||
                  attribute.name === 'lossOfRentSI' ||
                  attribute.name === 'rentForAlternativeAccommodationSI' ||
                  (values?.otherDetails?.premisesRentedOut
                    !== 'Yes' ? attribute?.name?.toString() === 'rentPerMonth' : false) ||
                  (values?.otherDetails?.premisesRentedOut
                    !== 'Yes' ? attribute?.name?.toString() === 'Indemnity_Period_Loss_of_Rent_In_Months' : false) ||
                  (values?.otherDetails?.ownerOccupant
                    !== 'Yes' ? attribute?.name?.toString() === 'accomodationRentPerMonth' : false) ||
                  (values?.otherDetails?.ownerOccupant
                    !== 'Yes' ? attribute?.name?.toString() === 'accomodationIndemnityPeriodInMonths' : false) ||
                  isQuoteReadOnly,
                className: `${loadingPremium ||
                  values?.isQuoteSaved ||
                  values?.isQuoteSaving
                  ? 'border-neutral-dark'
                  : ''
                  }`,
                iconPre: (
                  <Text
                    severity={
                      loadingPremium ||
                        values?.isQuoteSaved ||
                        values?.isQuoteSaving
                        ? 'neutral-darker'
                        : 'info'
                    }
                  >
                    {branding.currency}
                  </Text>
                ),
                data:
                  attribute.fieldType === 'select'
                    ? attribute.dataValues.map((dataval) => {
                      return {
                        label: dataval.value,
                        value: dataval.code,
                      };
                    })
                    : undefined,
                onKeyDown: (evt) =>
                  (evt.key === 'e' ||
                    evt.key === '-' ||
                    evt.key === '.')
                  // evt.key === '0')
                  //||
                  // evt.key === '0')
                  &&
                  evt.preventDefault(),
                value: attribute.fieldType === 'number' ? cov(coverName, attribute) : 7,
                onDataChange: (val, _) => {
                  setAddOrProceedDisabled(true);
                  setSaveDisabled(true);
                  setIsCalculateDisabled(false);
                  if (!showCalculatePremiumButton) {
                    setShowCalculatePremiumButton(true);
                  }
                  if (values?.addOnCovers["Loss of Rent"]?.selected === true) {

                    let r1 = values?.addOnCovers["Loss of Rent"]?.attributes?.Indemnity_Period_Loss_of_Rent_In_Months;

                    // let r2 = values?.addOnCovers["Loss of Rent"]?.attributes?.Indemnity_Period_Loss_of_Rent_In_Months
                    let r2 = val
                    // console.log("r1",r1)
                    // console.log("r2",r2)
                    if ((r1 !== '' && r2 !== '') && attribute.name === 'rentPerMonth') {




                      let r3 = r1 * r2
                      // console.log("r3",r3)
                      setFieldValue(
                        `addOnCovers.${coverName}.attributes.${attributes
                          ?.filter((attr) => attr.showOnScreen)
                          ?.find(
                            (attr) =>
                              attr?.displayName?.toLowerCase() ===
                              'loss of rent si',
                          )?.name
                        }`,
                        r3,
                      );

                      setFieldValue(
                        `addOnCovers.Earthquake Fire and Shock.attributes.earthquakeFireAndShockSI`,
                        `${parseFloat(values?.riskLocations?.stock?.totalSumInsured) +
                        parseFloat(
                          r3
                        )
                        }`,
                      );
                      setFieldValue(
                        `addOnCovers.Terrorism Damage Cover.attributes.terrorismDamageCoverSI`,
                        `${parseFloat(values?.riskLocations?.stock?.totalSumInsured) +
                        parseFloat(
                          r3
                        )
                        }`,
                      );
                      // console.log('after earth')

                    }

                  }
                  // let c = 'Rent for an Alternative Accommodation'


                  if (values?.addOnCovers["Rent for an Alternative Accommodation"]?.selected === true) {

                    let c1 = values?.addOnCovers["Rent for an Alternative Accommodation"]?.attributes?.accomodationIndemnityPeriodInMonths;

                    // let r2 = values?.addOnCovers["Loss of Rent"]?.attributes?.Indemnity_Period_Loss_of_Rent_In_Months
                    let c2 = val


                    if ((c1 !== '' && c2 !== '') && attribute?.name === 'accomodationRentPerMonth') {



                      let c3 = c1 * c2

                      setFieldValue(
                        `addOnCovers.${coverName}.attributes.${attributes
                          .filter((attr) => attr.showOnScreen)
                          ?.find(
                            (attr) =>
                              attr?.displayName?.toLowerCase() ===
                              'rent for alternative accommodation si',
                          )?.name
                        }`,
                        c3,
                      );
                      setFieldValue(
                        `addOnCovers.Earthquake Fire and Shock.attributes.earthquakeFireAndShockSI`,
                        `${parseFloat(values?.riskLocations?.stock?.totalSumInsured) +
                        parseFloat(
                          c3
                        )
                        }`,
                      );
                      setFieldValue(
                        `addOnCovers.Terrorism Damage Cover.attributes.terrorismDamageCoverSI`,
                        `${parseFloat(values?.riskLocations?.stock?.totalSumInsured) +
                        parseFloat(
                          c3
                        )
                        }`,
                      );
                    }

                  }
                  updateFireQuote({
                    ...fireQuote,
                    isPremiumCalculating: null,
                  });
                },
              }
              : {
                type: `${attribute.fieldType}`,
                label: (
                  <Text type={'label'}>
                    {attribute.displayName}{' '}

                    <Text severity="error">{(attribute?.name !== 'Terrorism Third Party Liability' && attribute?.name !== 'Terrorism Political Violence') ? '*' : ''}</Text>
                  </Text>
                ),
                name: `addOnCovers.${coverName}.attributes.${attribute.name}`,
                disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' ||
                  (values?.otherDetails?.premisesRentedOut
                    !== 'Yes' ? attribute?.name?.toString() === 'Indemnity_Period_Loss_of_Rent_In_Months' : false) ||
                  (values?.otherDetails?.ownerOccupant
                    !== 'Yes' ? attribute?.name?.toString() === 'accomodationIndemnityPeriodInMonths' : false) ||
                  ((attribute?.displayName?.toLowerCase() ===
                    'name of appointee' ||
                    attribute?.displayName?.toLowerCase() ===
                    'relationship of appointee') &&
                    moment(new Date(), 'DD/MM/YYYY').diff(
                      moment(
                        values?.addOnCovers[`${coverName}`][
                        `attributes`
                        ][
                        `${attributes
                          .filter((attr) => attr.showOnScreen)
                          ?.find(
                            (attr) =>
                              attr?.displayName?.toLowerCase() ===
                              'nominee dob',
                          )?.name
                        }`
                        ],
                        'DD/MM/YYYY',
                      ),
                      'years',
                    ) >= MINOR_THRESHOLD_AGE) ||
                  loadingPremium ||
                  values?.isQuoteSaved ||
                  values?.isQuoteSaving ||
                  isQuoteReadOnly,
                data:
                  attribute.fieldType === 'select'
                    ? attribute.dataValues.map((dataval) => {
                      return {
                        label: dataval.value,
                        value: dataval.code,
                      };
                    })
                    : undefined,
                onKeyDown: (evt) => {
                  if (
                    (attribute?.displayName
                      ?.toString()
                      ?.toLowerCase() === 'nominee name' ||
                      attribute?.displayName
                        ?.toString()
                        ?.toLowerCase() ===
                      'name of appointee') &&
                    (evt?.target?.value?.toString()?.length ===
                      0 ||
                      evt?.target?.value
                        ?.toString()
                        ?.endsWith(' ')) &&
                    evt.key === ' '
                  ) {
                    evt.preventDefault();
                  }
                },
                onDataChange: (val, _) => {
                  setAddOrProceedDisabled(true);
                  setSaveDisabled(true);
                  setIsCalculateDisabled(false);
                  if (!showCalculatePremiumButton) {
                    setShowCalculatePremiumButton(true);
                  }

                  // let r = 'Loss of Rent'
                  // console.log("addoncover",values?.riskLocations?.addOnCovers["Loss of Rent"]?.selected)

                  if (values?.addOnCovers["Loss of Rent"]?.selected === true) {
                    // console.log("1344",values)
                    let r1 = values?.addOnCovers["Loss of Rent"]?.attributes?.rentPerMonth;

                    // let r2 = values?.addOnCovers["Loss of Rent"]?.attributes?.Indemnity_Period_Loss_of_Rent_In_Months
                    let r2 = val
                    // console.log("r1",r1)
                    // console.log("r2",r2)
                    if ((r1 !== '' && r2 !== '') && attribute.name === 'Indemnity_Period_Loss_of_Rent_In_Months') {



                      // console.log("r1",r1)
                      // console.log("r2",r2)
                      let r3 = r1 * r2
                      // console.log("r3",r3)
                      setFieldValue(
                        `addOnCovers.${coverName}.attributes.${attributes
                          .filter((attr) => attr.showOnScreen)
                          ?.find(
                            (attr) =>
                              attr?.displayName?.toLowerCase() ===
                              'loss of rent si',
                          )?.name
                        }`,
                        r3,
                      );
                      // console.log('b4 earth',values)
                      setFieldValue(
                        `addOnCovers.Earthquake Fire and Shock.attributes.earthquakeFireAndShockSI`,
                        `${parseFloat(values?.riskLocations?.stock?.totalSumInsured) +
                        parseFloat(
                          r3
                        )
                        }`,
                      );
                      setFieldValue(
                        `addOnCovers.Terrorism Damage Cover.attributes.terrorismDamageCoverSI`,
                        `${parseFloat(values?.riskLocations?.stock?.totalSumInsured) +
                        parseFloat(
                          r3
                        )
                        }`,
                      );
                      // console.log('after earth')

                    }

                  }
                  // let c = 'Rent for an Alternative Accommodation'


                  if (values?.addOnCovers["Rent for an Alternative Accommodation"]?.selected === true) {

                    let c1 = values?.addOnCovers["Rent for an Alternative Accommodation"]?.attributes?.accomodationRentPerMonth;

                    // let r2 = values?.addOnCovers["Loss of Rent"]?.attributes?.Indemnity_Period_Loss_of_Rent_In_Months
                    let c2 = val


                    if ((c1 !== '' && c2 !== '') && attribute.name === 'accomodationIndemnityPeriodInMonths') {
                      //&& attribute.name === 'accomodationRentPerMonth' // && attribute.name === 'accomodationIndemnityPeriodInMonths'



                      let c3 = c1 * c2

                      setFieldValue(
                        `addOnCovers.${coverName}.attributes.${attributes
                          .filter((attr) => attr.showOnScreen)
                          ?.find(
                            (attr) =>
                              attr?.displayName?.toLowerCase() ===
                              'rent for alternative accommodation si',
                          )?.name
                        }`,
                        c3,
                      );
                      setFieldValue(
                        `addOnCovers.Earthquake Fire and Shock.attributes.earthquakeFireAndShockSI`,
                        `${parseFloat(values?.riskLocations?.stock?.totalSumInsured) +
                        parseFloat(
                          c3
                        )
                        }`,
                      );
                      setFieldValue(
                        `addOnCovers.Terrorism Damage Cover.attributes.terrorismDamageCoverSI`,
                        `${parseFloat(values?.riskLocations?.stock?.totalSumInsured) +
                        parseFloat(
                          c3
                        )
                        }`,
                      );
                    }

                  }

                  // updateMotorQuote({
                  //   ...motorQuote,
                  //   isPremiumCalculating: null,
                  // });
                  if (
                    attribute?.displayName?.toLowerCase() ===
                    'nominee dob' &&
                    moment(new Date(), 'DD/MM/YYYY').diff(
                      moment(val, 'DD/MM/YYYY'),
                      'years',
                    ) >= MINOR_THRESHOLD_AGE
                  ) {
                    setFieldValue(
                      `addOnCovers.${coverName}.attributes.${attributes
                        .filter((attr) => attr.showOnScreen)
                        ?.find(
                          (attr) =>
                            attr?.displayName?.toLowerCase() ===
                            'name of appointee',
                        )?.name
                      }`,
                      '',
                    );
                    setFieldValue(
                      `addOnCovers.${coverName}.attributes.${attributes
                        .filter((attr) => attr.showOnScreen)
                        ?.find(
                          (attr) =>
                            attr?.displayName?.toLowerCase() ===
                            'relationship of appointee',
                        )?.name
                      }`,
                      '',
                    );
                  }
                },
              };
          })
        : [];
    };
    const other_props_attribute_form = {
      flow: 'cols',
      repeat: repeatData,
      gapX: 8,
      gapY: 0.5,
      size: 'full',
    };
    const data = [
      {


        grid_data:
          fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.value
            ?.toString()
            ?.toLowerCase() !== 'home building and home contents'
            ? [
              {
                type: 'select',
                name: `riskLocations.occupancy.value`,
                colSpan: repeat,
                size: 'full',
                disabled:
                  loadingPremium || isSavingLocation || isQuoteReadOnly ||
                  fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval',

                onDataChange: (val, _) => {



                },
              },
            ] : []
      },

      {
        grid_type: 'input',
        title: (
          <Text className={'font-semibold'} severity={'dark'}>
            Address
          </Text>
        ),
        //changed
        // isBorderRequired: true,
        // borderClassName: 'border-t-2 border-neutral pt-2',
        grid_data: [
          {
            type: 'text',
            size: 'full',
            maxLength: "200",
            colSpan: repeat,
            name: `riskLocations.addressDetails.addressLine1`,
            disabled:
              loadingPremium || isSavingLocation || isQuoteReadOnly ||
              fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval',
            label: (
              <Text type={'label'}>
                Address <Text severity={'error'}>*</Text>
              </Text>
            ),
            onDataChange: (val, setFieldValue) => {
              setFieldValue(
                `riskLocations.addressDetails.addressLine1`,
                val,
              );
              setAddOrProceedDisabled(true);
              setSaveDisabled(true);
              setIsCalculateDisabled(false);
              setFieldValue(
                `riskLocations.isLocationSaved`,
                false,
              );
            },
          },
          {
            type: 'input-lookup',
            size: 'full',
            onLookup: onPermAddrLookup,
            loading: loadingPermCustAddr,
            // disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' ||
            //   loadingPermCustAddr ||
            //   loadingPremium ||
            //   isSavingLocation ||
            //   isQuoteReadOnly,
            disabled: true,
            name: `riskLocations.addressDetails.pincode`,
            label: (
              <Text type={'label'}>
                Pin Code <Text severity={'error'}>*</Text>
              </Text>
            ),
            onDataChange: (val, setFieldValue) => {
              setFieldValue(
                `riskLocations.isLocationSaved`,
                false,
              );

              setFieldValue(
                `riskLocations.addressDetails.state`,
                '',
              );
              setFieldValue(
                `riskLocations.addressDetails.district`,
                '',
              );

              setAddOrProceedDisabled(true);
              setSaveDisabled(true);
              setIsCalculateDisabled(false);
            },
            onKeyDown: (e) => {
              if (
                !e.key.match(/^[0-9]+$/) &&
                !['arrowleft', 'arrowright', 'backspace']?.includes(
                  e?.key?.toString()?.toLowerCase(),
                )
              ) {
                e.preventDefault();
              }
            },
          },
          {
            type: 'text',
            size: 'full',
            name: `riskLocations.addressDetails.state`,
            disabled: true,
            label: (
              <Text type={'label'}>
                State <Text severity={'error'}>*</Text>
              </Text>
            ),
          },
          {
            type: 'text',
            size: 'full',
            name: `riskLocations.addressDetails.district`,
            disabled: true,
            label: (
              <Text type={'label'}>
                District <Text severity={'error'}>*</Text>
              </Text>
            ),
          },

          // values?.riskLocations
          //   ?.slice(0, riskLocationIndex)
          //   ?.find(
          //     (riskLocation) =>
          //       riskLocation?.addressDetails?.pincode
          //         ?.toString()
          //         ?.toLowerCase() ===
          //       values?.riskLocations[
          //         riskLocationIndex
          //       ]?.addressDetails?.pincode
          //         ?.toString()
          //         ?.toLowerCase(),
          //   )
          //   ? {
          //       type: 'checkbox',
          //       name: `riskLocations[${riskLocationIndex}].addressDetails.isSamePremise`,
          //       label: 'Is Risk Location At Same Premises',
          //       size: 'full',
          //       colSpan: repeat,
          //       disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' ||
          //         loadingPermCustAddr ||
          //         loadingPremium ||
          //         isSavingLocation ||
          //         isQuoteReadOnly,
          //       onDataChange: (val, _) => {
          //         setAddOrProceedDisabled(true);
          //         setSaveDisabled(true);
          //         setIsCalculateDisabled(false);
          //         setFieldValue(
          //           `riskLocations[${riskLocationIndex}].isLocationSaved`,
          //           false,
          //         );
          //       },
          //     }
          //   : null,
        ]?.filter((d) => d),
      },
      {
        grid_type: 'input',
        title: (
          <Text className={'font-semibold'} severity={'dark'}>
            Risk Sum Insured
          </Text>
        ),
        // isBorderRequired: true,
        borderClassName: 'border-t-2 border-neutral pt-2',
        grid_data: [
          (fireQuote.basisOfValuation === 'Reinstatement value'
          ) ?
            {
              type: 'number',
              size: 'full',
              disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' ||
                loadingPremium || isSavingLocation || isQuoteReadOnly,
              name: `riskLocations.riskSumInsured.costOfConstruction`,
              //min: 0,
              //max: 12,
              maxLength: '9',
              onKeyDown: (evt) =>
                (evt.key === 'e' ||
                  evt.key === '-') &&
                evt.preventDefault(),
              className:
                loadingPremium || isSavingLocation || isQuoteReadOnly
                  ? 'border-neutral-dark'
                  : '',
              iconPre: (
                <Text
                  severity={
                    loadingPremium ||
                      isSavingLocation ||
                      isQuoteReadOnly
                      ? 'neutral'
                      : 'info'
                  }
                >
                  {branding?.currency}
                </Text>
              ),
              label: (
                <Text type={'label'}>
                  Cost of Construction non (in per Sq.Ft.) <Text severity={'error'}>*</Text>
                </Text>
              ),
              onDataChange: (val, _) => {
                setAddOrProceedDisabled(true);
                setSaveDisabled(true);
                setIsCalculateDisabled(false);
                setFieldValue(
                  `riskLocations.isLocationSaved`,
                  false,
                );
                if (
                  !isNaN(parseFloat(val)) &&
                  !isNaN(
                    parseFloat(
                      values?.riskLocations?.riskSumInsured?.carpetArea,
                    ),
                  )
                ) {
                  setFieldValue(
                    `riskLocations.riskSumInsured.buildingValue`,
                    `${parseFloat(val) *
                    parseFloat(
                      values?.riskLocations?.riskSumInsured?.carpetArea,
                    )
                    }`,
                  );
                } else if (

                  !isNaN(
                    parseFloat(
                      values?.riskLocations?.riskSumInsured?.carpetArea,
                    ),
                  )
                ) {
                  setFieldValue(
                    `riskLocations.riskSumInsured.buildingValue`,
                    values?.riskLocations?.riskSumInsured?.carpetArea,

                  );
                  // setFieldValue(
                  //   `riskLocations.riskSumInsured.totalBuildingSI`,
                  //   values?.riskLocations?.riskSumInsured?.buildingValue,

                  // );
                } else if (!isNaN(parseFloat(val))) {
                  //console.log("Inside 2nd elseif");
                  setFieldValue(
                    `riskLocations.riskSumInsured.buildingValue`,
                    val,
                  );
                  // setFieldValue(
                  //   `riskLocations.riskSumInsured.totalBuildingSI`,
                  //   values?.riskLocations?.riskSumInsured?.buildingValue,

                  // );
                } else {
                  //console.log("inside else");
                  setFieldValue(
                    `riskLocations.riskSumInsured.buildingValue`,
                    '',
                  );
                }
                // //if (!isNaN(parseFloat(values?.riskLocations?.riskSumInsured?.buildingValue))){
                //   setFieldValue(
                //     `riskLocations.riskSumInsured.totalBuildingSI`,
                //     values?.riskLocations?.riskSumInsured?.buildingValue,

                //   );
                // //}


              },
            } : null,
          (fireQuote.basisOfValuation === 'Reinstatement value'
          ) ?
            {
              type: 'number',
              min: 0,
              size: 'full',
              name: `riskLocations.riskSumInsured.carpetArea`,
              disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' ||
                loadingPremium || isSavingLocation || isQuoteReadOnly,
              onKeyDown: (evt) =>
                (evt.key === 'e' ||
                  evt.key === '-') &&
                evt.preventDefault(),
              className:
                loadingPremium || isSavingLocation || isQuoteReadOnly
                  ? 'border-neutral-dark'
                  : '',
              iconPre: (
                <Text
                  severity={
                    loadingPremium ||
                      isSavingLocation ||
                      isQuoteReadOnly
                      ? 'neutral'
                      : 'info'
                  }
                >
                  {branding?.currency}
                </Text>
              ),
              label: (
                <Text type={'label'}>
                  Carpet Area in Sq.Ft
                  <Text severity={'error'}>*</Text>
                </Text>
              ),
              onDataChange: (val, _) => {
                setAddOrProceedDisabled(true);
                setSaveDisabled(true);
                setIsCalculateDisabled(false);
                setFieldValue(
                  `riskLocations.isLocationSaved`,
                  false,
                );
                if (
                  !isNaN(parseFloat(val)) &&
                  !isNaN(
                    parseFloat(
                      values?.riskLocations?.riskSumInsured?.costOfConstruction,
                    ),
                  )
                ) {
                  setFieldValue(
                    `riskLocations.riskSumInsured.buildingValue`,
                    `${parseFloat(val) *
                    parseFloat(
                      values?.riskLocations?.riskSumInsured?.costOfConstruction,
                    )
                    }`,
                  );
                } else if (
                  !isNaN(
                    parseFloat(
                      values?.riskLocations?.riskSumInsured?.costOfConstruction,
                    ),
                  )
                ) {
                  setFieldValue(
                    `riskLocations.riskSumInsured.buildingValue`,
                    values?.riskLocations?.riskSumInsured?.costOfConstruction,
                  );
                } else if (!isNaN(parseFloat(val))) {

                  setFieldValue(
                    `riskLocations.riskSumInsured.buildingValue`,
                    val,
                  );
                } else {

                  setFieldValue(
                    `riskLocations.riskSumInsured.buildingValue`,
                    '',
                  );
                }
                // if (!isNaN(parseFloat(values?.riskLocations?.riskSumInsured?.buildingValue))){
                //   setFieldValue(
                //     `riskLocations.riskSumInsured.totalBuildingSI`,
                //     values?.riskLocations?.riskSumInsured?.buildingValue,

                //   );
                // }


              },
            }
            : null
          ,
          {
            type: 'number',
            min: 0,
            size: 'full',
            name: `riskLocations.riskSumInsured.buildingValue`,

            disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' || loadingPremium || isSavingLocation || isQuoteReadOnly,
            onKeyDown: (evt) =>
              (evt.key === 'e' ||
                evt.key === '-' ||
                evt.key === '.') &&
              evt.preventDefault(),
            className:
              loadingPremium || isSavingLocation || isQuoteReadOnly
                ? 'border-neutral-dark'
                : '',
            iconPre: (
              <Text
                severity={
                  loadingPremium ||
                    isSavingLocation ||
                    isQuoteReadOnly
                    ? 'neutral'
                    : 'info'
                }
              >
                {branding?.currency}
              </Text>
            ),
            label: (
              <Text type={'label'}>
                Building Value
                <Text severity={'error'}></Text>
              </Text>
            ),
            onDataChange: (val, _) => {
              setAddOrProceedDisabled(true);
              setSaveDisabled(true);
              setIsCalculateDisabled(false);
              setFieldValue(
                `riskLocations.isLocationSaved`,
                false,
              );
            },
          },
          {
            type: 'number',
            min: 0,
            size: 'full',
            name: `riskLocations.riskSumInsured.additionalStructure`,
            onKeyDown: (evt) =>
              (evt.key === 'e' ||
                evt.key === '-' ||
                evt.key === '.') &&
              evt.preventDefault(),
            className:
              loadingPremium || isSavingLocation || isQuoteReadOnly
                ? 'border-neutral-dark'
                : '',
            disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' ||
              loadingPremium || isSavingLocation || isQuoteReadOnly,
            iconPre: (
              <Text
                severity={
                  loadingPremium ||
                    isSavingLocation ||
                    isQuoteReadOnly
                    ? 'neutral'
                    : 'info'
                }
              >
                {branding?.currency}
              </Text>
            ),
            label: (
              <Text type={'label'}>
                Additional Structure <Text severity={'error'}></Text>
              </Text>
            ),
            onDataChange: (val, _) => {
              setAddOrProceedDisabled(true);
              setSaveDisabled(true);
              setIsCalculateDisabled(false);
              setFieldValue(
                `riskLocations.isLocationSaved`,
                false,
              );
            },
          },
          {
            type: 'number',
            // min: 0,
            size: 'full',
            name: `riskLocations.riskSumInsured.totalBuildingSI`,
            onKeyDown: (evt) =>
              (evt.key === 'e' ||
                evt.key === '-' ||
                evt.key === '.') &&
              evt.preventDefault(),
            className:
              loadingPremium || isSavingLocation || isQuoteReadOnly
                ? 'border-neutral-dark'
                : '',
            disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' ||
              loadingPremium || isSavingLocation || isQuoteReadOnly,
            iconPre: (
              <Text
                severity={
                  loadingPremium ||
                    isSavingLocation ||
                    isQuoteReadOnly
                    ? 'neutral'
                    : 'info'
                }
              >
                {branding?.currency}
              </Text>
            ),
            label: (
              <Text type={'label'}>
                Total Building SI <Text severity={'error'}></Text>
              </Text>
            ),
            onDataChange: (val, _) => {
              setAddOrProceedDisabled(true);
              setSaveDisabled(true);
              setIsCalculateDisabled(false);
              setFieldValue(
                `riskLocations.isLocationSaved`,
                false,
              );

            },
          },
        ]?.filter((d) => d),
      },
      {
        grid_type: 'input',
        title: (
          <Text className={'font-semibold'} severity={'dark'}>
            Contents
          </Text>
        ),
        // isBorderRequired: true,
        borderClassName: 'border-t-2 border-neutral pt-2',
        grid_data: [
          {
            type: 'number',

            size: 'full',
            disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' || true,
            name: `riskLocations.stock.generalContentSI`,
            onKeyDown: (evt) =>
              (evt.key === 'e' ||
                evt.key === '-' ||
                evt.key === '.') &&
              evt.preventDefault(),
            className:
              loadingPremium || isSavingLocation || isQuoteReadOnly
                ? 'border-neutral-dark'
                : '',
            // disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' ||
            //   loadingPremium || isSavingLocation || isQuoteReadOnly,
            iconPre: (
              <Text
                severity={
                  loadingPremium ||
                    isSavingLocation ||
                    isQuoteReadOnly
                    ? 'neutral'
                    : 'info'
                }
              >
                {branding?.currency}
              </Text>
            ),
            label: (
              <Text type={'label'}>
                General Contents SI <Text severity={'error'}></Text>
              </Text>
            ),
            onDataChange: (val, _) => {


              setAddOrProceedDisabled(true);
              setSaveDisabled(true);
              setIsCalculateDisabled(false);
              setFieldValue(
                `riskLocations.isLocationSaved`,
                false,
              );
            },
          },
          {
            type: 'select',
            min: 0,
            size: 'full',
            name: `riskLocations.stock.additionalContent`,
            onKeyDown: (evt) =>
              (evt.key === 'e' ||
                evt.key === '-' ||
                evt.key === '.') &&
              evt.preventDefault(),
            className:
              loadingPremium || isSavingLocation || isQuoteReadOnly
                ? 'border-neutral-dark'
                : '',
            disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' ||
              loadingPremium || isSavingLocation || isQuoteReadOnly,
            // iconPre: (
            //   <Text
            //     severity={
            //       loadingPremium ||
            //         isSavingLocation ||
            //         isQuoteReadOnly
            //         ? 'neutral'
            //         : 'info'
            //     }
            //   >
            //     {branding?.currency}
            //   </Text>
            // ),
            label: (
              <Text type={'label'}>
                Additional Content{' '} <Text severity={'error'}></Text>
              </Text>
            ),
            data: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
            onDataChange: (val, _) => {
              if (val?.toString()?.toLowerCase() === 'no') {
                setFieldValue(
                  `riskLocations.stock.additionalContentSI`,
                  '',
                );
              }
              setAddOrProceedDisabled(true);
              setSaveDisabled(true);
              setIsCalculateDisabled(false);
              setFieldValue(
                `riskLocations.isLocationSaved`,
                false,
              );
            },
          },
          {
            type: 'number',
            min: 0,
            size: 'full',
            name: `riskLocations.stock.additionalContentSI`,
            onKeyDown: (evt) =>
              (evt.key === 'e' ||
                evt.key === '-' ||
                evt.key === '.') &&
              evt.preventDefault(),
            className:
              loadingPremium || isSavingLocation || isQuoteReadOnly
                ? 'border-neutral-dark'
                : '',
            disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' || values?.riskLocations
              ?.stock?.additionalContent
              ?.toString()
              ?.toLowerCase() !== 'yes' ||
              loadingPremium || isSavingLocation || isQuoteReadOnly,
            iconPre: (
              <Text
                severity={
                  loadingPremium ||
                    isSavingLocation ||
                    isQuoteReadOnly
                    ? 'neutral'
                    : 'info'
                }
              >
                {branding?.currency}
              </Text>
            ),
            label: (
              <Text type={'label'}>
                Additional Content SI <Text severity={'error'}>
                  {values?.riskLocations?.stock?.additionalContent
                    ?.toString()
                    ?.toLowerCase() === 'yes'
                    ? '*'
                    : ''}
                </Text>
              </Text>
            ),
            onDataChange: (val, _) => {


              setAddOrProceedDisabled(true);
              setSaveDisabled(true);
              setIsCalculateDisabled(false);
              setFieldValue(
                `riskLocations.isLocationSaved`,
                false,
              );
              // if (
              //   !isNaN(parseFloat(val)) &&
              //   !isNaN(
              //     parseFloat(
              //       values?.riskLocations?.stock?.valuableContentSI,
              //     ),
              //   )
              // ) {
              //   setFieldValue(
              //     `riskLocations.stock.totalContentSI`,
              //     `${parseFloat(val) +
              //     parseFloat(
              //       values?.riskLocations?.stock?.valuableContentSI,
              //     )
              //     }`,
              //   );
              // } else
              //  if (
              //   !isNaN(
              //     parseFloat(
              //       values?.riskLocations?.stock?.valuableContentSI,
              //     ),
              //   )
              // ) {
              //   setFieldValue(
              //     `riskLocations.stock.totalContentSI`,
              //     values?.riskLocations?.stock?.valuableContentSI,
              //   );
              // } else
              //  if (
              //   !isNaN(parseFloat(val))
              //   ) {
              //     setFieldValue(
              //       `riskLocations.stock.totalContentSI`,
              //       (parseFloat(val) +
              //         parseFloat(values?.riskLocations?.stock?.totalContentSI)
              //       ),
              //     );
              // }
              //  else {

              //   setFieldValue(
              //     `riskLocations.stock.totalContentSI`,
              //     '',
              //   );
              // }
            },
          },
          {
            type: 'select',
            min: 0,
            size: 'full',
            name: `riskLocations.stock.valuableContent`,
            onKeyDown: (evt) =>
              (evt.key === 'e' ||
                evt.key === '-' ||
                evt.key === '.') &&
              evt.preventDefault(),
            className:
              loadingPremium || isSavingLocation || isQuoteReadOnly
                ? 'border-neutral-dark'
                : '',
            disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' ||
              loadingPremium || isSavingLocation || isQuoteReadOnly,
            // iconPre: (
            //   <Text
            //     severity={
            //       loadingPremium ||
            //         isSavingLocation ||
            //         isQuoteReadOnly
            //         ? 'neutral'
            //         : 'info'
            //     }
            //   >
            //     {branding?.currency}
            //   </Text>
            // ),
            label: (
              <Text type={'label'}>
                Valuable Content?{' '} <Text severity={'error'}></Text>
              </Text>
            ),
            data: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
            onDataChange: (val, _) => {
              if (val?.toString()?.toLowerCase() === 'no') {
                setFieldValue(
                  `riskLocations.stock.valuableContentSI`,
                  '',
                );
              }
              setAddOrProceedDisabled(true);
              setSaveDisabled(true);
              setIsCalculateDisabled(false);
              setFieldValue(
                `riskLocations.isLocationSaved`,
                false,
              );
            },
          },
          {
            type: 'number',
            min: 0,
            size: 'full',
            name: `riskLocations.stock.valuableContentSI`,
            onKeyDown: (evt) =>
              (evt.key === 'e' ||
                evt.key === '-' ||
                evt.key === '.') &&
              evt.preventDefault(),
            className:
              loadingPremium || isSavingLocation || isQuoteReadOnly
                ? 'border-neutral-dark'
                : '',
            disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' || values?.riskLocations
              ?.stock?.valuableContent
              ?.toString()
              ?.toLowerCase() !== 'yes' ||
              loadingPremium || isSavingLocation || isQuoteReadOnly,
            iconPre: (
              <Text
                severity={
                  loadingPremium ||
                    isSavingLocation ||
                    isQuoteReadOnly
                    ? 'neutral'
                    : 'info'
                }
              >
                {branding?.currency}
              </Text>
            ),
            label: (
              <Text type={'label'}>
                Valuable Content SI <Text severity={'error'}>
                  {values?.riskLocations?.stock?.valuableContent
                    ?.toString()
                    ?.toLowerCase() === 'yes'
                    ? '*'
                    : ''}
                </Text>
              </Text>
            ),
            onDataChange: (val, _) => {


              setAddOrProceedDisabled(true);
              setSaveDisabled(true);
              setIsCalculateDisabled(false);
              setFieldValue(
                `riskLocations.isLocationSaved`,
                false,
              );
              // if (
              //   !isNaN(parseFloat(val)) &&
              //   !isNaN(
              //     parseFloat(
              //       values?.riskLocations?.stock?.additionalContentSI,
              //     ),
              //   )
              // ) {
              //   setFieldValue(
              //     `riskLocations.stock.totalContentSI`,
              //     `${parseFloat(val) +
              //     parseFloat(
              //       values?.riskLocations?.stock?.additionalContentSI,
              //     )
              //     }`,
              //   );
              // } else 
              // if (!isNaN(parseFloat(val))) {

              //   setFieldValue(
              //     `riskLocations.stock.totalContentSI`,
              //       (parseFloat(val) +
              //         parseFloat(values?.riskLocations?.stock?.totalContentSI)
              //       ),

              //   );
              // } 
              // else {

              //   setFieldValue(
              //     `riskLocations.stock.totalContentSI`,
              //     '',
              //   );
              // }
            },
          },
          {
            type: 'number',
            min: 0,
            size: 'full',
            name: `riskLocations.stock.totalContentSI`,
            onKeyDown: (evt) =>
              (evt.key === 'e' ||
                evt.key === '-' ||
                evt.key === '.') &&
              evt.preventDefault(),
            className:
              loadingPremium || isSavingLocation || isQuoteReadOnly
                ? 'border-neutral-dark'
                : '',
            disabled: true,
            iconPre: (
              <Text
                severity={
                  loadingPremium ||
                    isSavingLocation ||
                    isQuoteReadOnly
                    ? 'neutral'
                    : 'info'
                }
              >
                {branding?.currency}
              </Text>
            ),
            label: (
              <Text type={'label'}>
                Total Contents SI<Text severity={'error'}>

                </Text>
              </Text>
            ),
            onDataChange: (val, _) => {


              setAddOrProceedDisabled(true);
              setSaveDisabled(true);
              setIsCalculateDisabled(false);





            },
          },
          {
            type: 'number',
            min: 0,
            size: 'full',
            disabled: true,
            name: `riskLocations.stock.totalSumInsured`,
            onKeyDown: (evt) =>
              (evt.key === 'e' ||
                evt.key === '-' ||
                evt.key === '.') &&
              evt.preventDefault(),
            className:
              loadingPremium || isSavingLocation || isQuoteReadOnly
                ? 'border-neutral-dark'
                : '',
            // disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' || loadingPremium || isSavingLocation || isQuoteReadOnly,
            iconPre: (
              <Text
                severity={
                  loadingPremium ||
                    isSavingLocation ||
                    isQuoteReadOnly
                    ? 'neutral'
                    : 'info'
                }
              >
                {branding?.currency}
              </Text>
            ),
            label: (
              <Text type={'label'}>
                Total Sum Insured<Text severity={'error'}>

                </Text>
              </Text>
            ),
            onDataChange: (val, _) => {
              setAddOrProceedDisabled(true);
              setSaveDisabled(true);
              setIsCalculateDisabled(false);
            },
          }
        ]?.filter((d) => d),
      },
      {
        grid_type: 'input',
        title: (
          <Text className={'font-semibold'} severity={'dark'}>
            Other Details
          </Text>
        ),

        grid_data: [
          // {
          //   type: 'radiogroup',
          //   className: 'my-2',
          //   colSpan: inputColSpans,
          //   itemBreak: inputColSpans === noOfColsMobile,
          //   name: 'searchType',
          //   data: [
          //     {
          //       label: 'Is your premises rented out',
          //       value: 'Is your premises rented out',
          //     },
          //     {
          //       label:'Are you Owner Occupant',
          //       value: 'Are you Owner Occupant',
          //     },
          //   ],
          //   onRadioChange: (val) => {
          //     // val === 'Search by Claim Number'
          //     //   ? setAdvancedSearch(false)
          //     //   : setAdvancedSearch(true);
          //   },
          // },
          {
            type: 'select',
            size: 'full',
            disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' || values?.otherDetails?.ownerOccupant
              ?.toString()
              ?.toLowerCase() === 'yes' ||
              values?.otherDetails?.ownerOccupant
              === '' || isQuoteReadOnly,
            // disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' ||
            //   loadingPremium ||
            //   isSavingLocation ||
            //   fireQuote?.status?.toString()?.trim()?.toLowerCase() ===
            //     'quote saved',
            label: (
              <Text type={'label'}>
                Is your premises rented out{' '} <Text severity={'error'}></Text>
              </Text>
            ),
            data: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
            name: `otherDetails.premisesRentedOut`,
            onDataChange: (val, _) => {
              setAddOrProceedDisabled(true);
              setSaveDisabled(true);
              setIsCalculateDisabled(false);
              if (val?.toString()?.toLowerCase() === 'no') {
                //   setFieldValue(
                //     `otherDetails.premisesRentedOut`,
                //     '',
                //   );
                setFieldValue(
                  `addOnCovers.Loss of Rent.selected`,
                  false,
                );
                // values['addOnCovers']['Loss of Rent']?.selected === false
                setFieldValue(
                  `addOnCovers.Loss of Rent.attributes.lossOfRentSI`,
                  '',
                );
                setFieldValue(
                  `addOnCovers.Loss of Rent.attributes.rentPerMonth`,
                  '',
                );
                setFieldValue(
                  `addOnCovers.Loss of Rent.attributes.Indemnity_Period_Loss_of_Rent_In_Months`,
                  '',
                );
                setFieldValue(
                  `addOnCovers.Earthquake Fire and Shock.attributes.earthquakeFireAndShockSI`,
                  `${parseFloat(values?.riskLocations?.stock?.totalSumInsured)
                  }`,
                );
                setFieldValue(
                  `addOnCovers.Terrorism Damage Cover.attributes.terrorismDamageCoverSI`,
                  `${parseFloat(values?.riskLocations?.stock?.totalSumInsured)
                  }`,
                );
              }
              else {
                setFieldValue(
                  `addOnCovers.Loss of Rent.selected`,
                  true,
                );
              }
            },
          },
          {
            type: 'select',
            size: 'full',
            disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' || values?.otherDetails?.premisesRentedOut
              ?.toString()
              ?.toLowerCase() === 'yes' ||
              values?.otherDetails?.premisesRentedOut
              === '' || isQuoteReadOnly,
            // disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' ||
            //   loadingPremium ||
            //   isSavingLocation ||
            //   fireQuote?.status?.toString()?.trim()?.toLowerCase() ===
            //     'quote saved',
            label: (
              <Text type={'label'}>
                Are you Owner Occupant{' '} <Text severity={'error'}></Text>
              </Text>
            ),
            data: [
              {
                label: 'Yes',
                value: 'Yes',
              },
              {
                label: 'No',
                value: 'No',
              },
            ],
            name: `otherDetails.ownerOccupant`,
            onDataChange: (val, _) => {
              setAddOrProceedDisabled(true);
              setSaveDisabled(true);
              setIsCalculateDisabled(false);
              if (val?.toString()?.toLowerCase() === 'no') {
                setFieldValue(
                  `addOnCovers.Rent for an Alternative Accommodation.selected`,
                  false,
                );
                setFieldValue(
                  `addOnCovers.Rent for an Alternative Accommodation.attributes.accomodationIndemnityPeriodInMonths`,
                  '',
                );
                setFieldValue(
                  `addOnCovers.Rent for an Alternative Accommodation.attributes.accomodationRentPerMonth`,
                  '',
                );
                setFieldValue(
                  `addOnCovers.Rent for an Alternative Accommodation.attributes.rentForAlternativeAccommodationSI`,
                  '',
                );
                setFieldValue(
                  `addOnCovers.Earthquake Fire and Shock.attributes.earthquakeFireAndShockSI`,
                  `${parseFloat(values?.riskLocations?.stock?.totalSumInsured)
                  }`,
                );
                setFieldValue(
                  `addOnCovers.Terrorism Damage Cover.attributes.terrorismDamageCoverSI`,
                  `${parseFloat(values?.riskLocations?.stock?.totalSumInsured)
                  }`,
                );
              }
              else {
                setFieldValue(
                  `addOnCovers.Rent for an Alternative Accommodation.selected`,
                  true,
                );
              }
              // if (val?.toString()?.toLowerCase() === 'no') {
              //   setFieldValue(
              //     `otherDetails.premisesRentedOut`,
              //     '',
              //   );
              // }
            },
          },
        ]?.filter((d) => d),
      },
      // {
      //   grid_type: 'data',
      //   title: (
      //     <Text className={'font-semibold'} severity={'dark'}>
      //       Coverages -1
      //   </Text>
      // ),
      // grid_data: [
      {
        grid_type: 'data',
        grid_data: [
          {
            colSpan: colSpan_for_Desktop,
            text: (
              <div className="mt-2">
                <div>
                  <Text severity="info">Add-on Covers</Text>

                  <Grid repeat={1} className="mt-2">

                    {riskCovers?.map((riskCover, idx) => (
                      // console.log("2696riskcovers", riskCovers),
                      // console.log("2706 cover : ", riskCover),
                      <Grid key={idx} repeat={2}>
                        {riskCover?.covers?.map((cover, idx) => (
                          (cover?.name.toString() !== 'Personal Accident Cover Self'
                            && cover?.name.toString() !== 'Personal Accident Cover Spouse'
                            && cover?.name.toString() !== 'Basic Fire Cover')
                            //|| cover?.name.toString() !== 'Personal Accident Cover Spouse'
                            ?
                            <div key={idx}>
                              <QuantaToggle
                                label={cover?.name}
                                name={`addOnCovers[${cover?.name}].selected`}
                                disabled={
                                  (loadingPremium || isSavingLocation || isQuoteReadOnly ||
                                    cover?.name.toString() === 'Earthquake Fire and Shock' ||
                                    (cover?.name.toString() === 'Terrorism Damage Cover'
                                      && fireQuote?.productKg?.toString() == 'Kotak Bharat Griha Raksha')
                                    ||
                                    cover?.name.toString() === 'Riot, Strikes, Malicious Damages'
                                    ||
                                    cover?.name.toString() === 'STFI'
                                  ) ||
                                  (values?.otherDetails?.premisesRentedOut
                                    !== 'Yes' ? cover?.name?.toString() === 'Loss of Rent' : false) ||
                                  (values?.otherDetails?.ownerOccupant
                                    !== 'Yes' ? cover?.name?.toString() === 'Rent for an Alternative Accommodation' : false)
                                  || fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval'
                                }
                                onChange={(val) => {
                                  setAddOrProceedDisabled(true);
                                  setSaveDisabled(true);
                                  setIsCalculateDisabled(false);
                                  setFieldValue(
                                    `addOnCovers[${cover?.name}].selected`,
                                    val,
                                  );
                                  if (!val) {
                                    cover?.attributes?.forEach(
                                      (attribute) => {
                                        setFieldValue(
                                          `addOnCovers[${cover?.name}].attributes[${attribute?.name}]`,
                                          '',
                                        );
                                        setFieldValue(
                                          `addOnCovers.Loss of Rent.attributes.lossOfRentSI`,
                                          '',
                                        );
                                        setFieldValue(
                                          `addOnCovers.Rent for an Alternative Accommodation.attributes.rentForAlternativeAccommodationSI`,
                                          '',
                                        );
                                      },
                                    );
                                    if (
                                      cover?.name.toString() === 'Loss of Rent') {

                                      setFieldValue(
                                        `addOnCovers.Loss of Rent.attributes.lossOfRentSI`,
                                        '',
                                      );
                                      setFieldValue(
                                        `addOnCovers.Earthquake Fire and Shock.attributes.earthquakeFireAndShockSI`,
                                        `${parseFloat(values?.riskLocations?.stock?.totalSumInsured)
                                        }`,
                                      );
                                      setFieldValue(
                                        `addOnCovers.Terrorism Damage Cover.attributes.terrorismDamageCoverSI`,
                                        `${parseFloat(values?.riskLocations?.stock?.totalSumInsured)
                                        }`,
                                      );
                                    }
                                    if (cover?.name.toString() === 'Rent for an Alternative Accommodation') {
                                      setFieldValue(
                                        `addOnCovers.Rent for an Alternative Accommodation.attributes.rentForAlternativeAccommodationSI`,
                                        '',
                                      );
                                      setFieldValue(
                                        `addOnCovers.Earthquake Fire and Shock.attributes.earthquakeFireAndShockSI`,
                                        `${parseFloat(values?.riskLocations?.stock?.totalSumInsured)
                                        }`,
                                      );
                                      setFieldValue(
                                        `addOnCovers.Terrorism Damage Cover.attributes.terrorismDamageCoverSI`,
                                        `${parseFloat(values?.riskLocations?.stock?.totalSumInsured)
                                        }`,
                                      );
                                    }
                                    if (cover?.name.toString() === 'Terrorism Damage Cover') {
                                      setFieldValue(
                                        `addOnCovers.Terrorism Damage Cover.attributes.terrorismDamageCoverSI`,
                                        `${parseFloat(values?.riskLocations?.stock?.totalSumInsured)
                                        }`,
                                      );
                                    }

                                  }
                                  setShowCalculatePremiumButton(true);
                                  // updateMotorQuote({
                                  //   ...motorQuote,
                                  //   isPremiumCalculating: null,
                                  // });
                                }}
                              />
                              {values?.addOnCovers?.[`${cover?.name}`]?.selected &&
                                (

                                  <InputGrid
                                    {...{
                                      data: attributeData(
                                        cover?.attributes,
                                        cover?.name,
                                      ),
                                      ...other_props_attribute_form,
                                    }}
                                  />
                                )}
                            </div>

                            : ''
                        ))}
                      </Grid>
                    ))}
                  </Grid>
                </div>
              </div>
            ),
          },
        ],
      },
      //   ]
      // },
      {
        grid_type: 'input',
        title: (
          <Text className={'font-semibold'} severity={'dark'}>
            Loading {'&'} Discount
          </Text>
        ),
        // isBorderRequired: true,
        borderClassName: 'border-t-2 border-neutral pt-2',
        grid_data: [
          {
            type: 'number',
            min: 0,
            size: 'full',
            disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' ||
              loadingPremium || isSavingLocation || isQuoteReadOnly,
            name: `loadingAndDiscount.discountPercentage`,
            onKeyDown: (evt) => {
              if (
                evt.key === 'e' ||
                evt.key === '-' ||
                (evt.target.value.toString().includes('.') &&
                  evt.target.value
                    .toString()
                    .substring(
                      evt.target.value.toString().indexOf('.') + 1,
                    ).length === 5 &&
                  evt.key.toString().toLowerCase() !== 'backspace' &&
                  evt.key.toString().toLowerCase() !== 'arrowleft' &&
                  evt.key.toString().toLowerCase() !== 'arrowright')
              ) {
                evt.preventDefault();
              }
            },
            className:
              loadingPremium || isSavingLocation || isQuoteReadOnly
                ? 'border-neutral-dark'
                : '',
            iconPre: (
              <Text
                severity={
                  loadingPremium ||
                    isSavingLocation ||
                    isQuoteReadOnly
                    ? 'neutral'
                    : 'info'
                }
              >
                {'%'}
              </Text>
            ),
            label: (
              <Text type={'label'}>
                Discount <Text severity={'error'}></Text>
              </Text>
            ),
            onDataChange: (val, _) => {
              setAddOrProceedDisabled(true);
              setSaveDisabled(true);
              setIsCalculateDisabled(false);
              setFieldValue(
                `riskLocations.isLocationSaved`,
                false,
              );
              if (parseFloat(val) > 100) {
                setFieldValue(
                  `riskLocations.loadingAndDiscount.discountPercentage`,
                  '',
                );
              }
            },
          },
          {
            type: 'number',
            min: 0,
            size: 'full',
            disabled: fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' ||
              loadingPremium || isSavingLocation || isQuoteReadOnly,
            name: `loadingAndDiscount.loadingPercentage`,
            onKeyDown: (evt) => {
              if (
                evt.key === 'e' ||
                evt.key === '-' ||
                (evt.target.value.toString().includes('.') &&
                  evt.target.value
                    .toString()
                    .substring(
                      evt.target.value.toString().indexOf('.') + 1,
                    ).length === 5 &&
                  evt.key.toString().toLowerCase() !== 'backspace' &&
                  evt.key.toString().toLowerCase() !== 'arrowleft' &&
                  evt.key.toString().toLowerCase() !== 'arrowright')
              ) {
                evt.preventDefault();
              }
            },
            className:
              loadingPremium || isSavingLocation || isQuoteReadOnly
                ? 'border-neutral-dark'
                : '',
            iconPre: (
              <Text
                severity={
                  loadingPremium ||
                    isSavingLocation ||
                    isQuoteReadOnly
                    ? 'neutral'
                    : 'info'
                }
              >
                {'%'}
              </Text>
            ),
            label: (
              <Text type={'label'}>
                Loading <Text severity={'error'}></Text>
              </Text>
            ),
            onDataChange: (val, _) => {
              setAddOrProceedDisabled(true);
              setSaveDisabled(true);
              setIsCalculateDisabled(false);
              setFieldValue(
                `riskLocations.isLocationSaved`,
                false,
              );
              if (parseFloat(val) > 100) {
                setFieldValue(
                  `riskLocations.loadingAndDiscount.loadingPercentage`,
                  '',
                );
              }
            },
          },
        ],
      },

      premiumData?.locationNetPremium ||
        premiumData?.locationGST ||
        premiumData?.locationTotalPremium
        ? {
          grid_type: 'data',
          title: (
            <Text className={'font-semibold'}>
              Premium
            </Text>
          ),
          // isBorderRequired: true,
          borderClassName: 'border-t-2 border-neutral pt-2',
          grid_data: [
            premiumData?.locationNetPremium
              ? {
                label: (
                  <Text type={'label'}>
                    Net Premium{' '}
                    <Text severity={'error'}></Text>
                  </Text>
                ),
                text: loadingPremium ? (
                  <Loading
                    className={
                      'flex flex-row justify-start items-center space-x-2 text-primary'
                    }
                    textSize={'normal'}
                  />
                ) : premiumData?.locationNetPremium ? (
                  `${CurrencyFormater(
                    premiumData?.locationNetPremium,
                    true,
                    false,
                    branding,
                    true,
                  )}`
                ) : (
                  <Text severity={'neutral'}>Not Captured</Text>
                ),
              }
              : null,
            premiumData?.locationGST
              ? {
                label: (
                  <Text type={'label'}>
                    GST <Text severity={'error'}></Text>
                  </Text>
                ),
                text: loadingPremium ? (
                  <Loading
                    className={
                      'flex flex-row justify-start items-center space-x-2 text-primary'
                    }
                    textSize={'normal'}
                  />
                ) : premiumData?.locationGST ? (
                  `${CurrencyFormater(
                    premiumData?.locationGST,
                    true,
                    false,
                    branding,
                    true,
                  )}`
                ) : (
                  <Text severity={'neutral'}>Not Captured</Text>
                ),
              }
              : null,
            // premiumData?.stampDuty
            //   ? {
            //       label: (
            //         <Text type={'label'}>
            //           Stamp Duty <Text severity={'error'}></Text>
            //         </Text>
            //       ),
            //       text: loadingPremium ? (
            //         <Loading
            //           className={
            //             'flex flex-row justify-start items-center space-x-2 text-primary'
            //           }
            //           textSize={'normal'}
            //         />
            //       ) : premiumData?.stampDuty ? (
            //         `${CurrencyFormater(
            //           premiumData?.stampDuty,
            //           true,
            //           false,
            //           branding,
            //           true,
            //         )}`
            //       ) : (
            //         <Text severity={'neutral'}>Not Captured</Text>
            //       ),
            //     }
            //   : null,
            premiumData?.locationTotalPremium
              ? {
                label: (
                  <Text type={'label'}>
                    Total Premium{' '}
                    <Text severity={'error'}></Text>
                  </Text>
                ),
                text: loadingPremium ? (
                  <Loading
                    className={
                      'flex flex-row justify-start items-center space-x-2 text-primary'
                    }
                    textSize={'normal'}
                  />
                ) : premiumData?.locationTotalPremium ? (
                  <Text severity={'info'} type={'larger'}>
                    {CurrencyFormater(
                      premiumData?.locationTotalPremium,
                      true,
                      false,
                      branding,
                      true,
                    )}
                  </Text>
                ) : (
                  <Text severity={'neutral'}>Not Captured</Text>
                ),
              }
              : null,
            warningMsg
              ? {
                colSpan: repeat,
                text: (
                  <Text
                    severity={'warning'}
                    className={'flex space-x-2 mt-2'}
                  >
                    <Text>
                      <FontAwesomeIcon
                        icon={faExclamationTriangle}
                      />
                    </Text>
                    <Text>{warningMsg}</Text>
                  </Text>
                ),
              }
              : null,
          ]?.filter((d) => d),
        }
        : null,
      !isQuoteReadOnly
        ? {
          grid_type: 'data',
          grid_data: [
            {
              colSpan: repeatReadOnly,
              text: (
                <Text
                  className={`flex ${screenType?.toString()?.toLowerCase() ===
                    'mobile'
                    ? 'flex-col space-y-4 mb-4'
                    : 'flex-row space-x-4 mt-8 mb-4'
                    } justify-end items-center`}
                >
                  <Text
                    className={
                      screenType?.toString()?.toLowerCase() ===
                        'mobile'
                        ? 'w-full'
                        : ''
                    }
                  >
                    <Button
                      disabled={
                        parseFloat(
                          values?.riskLocations
                            ?.locationSumInsured,
                        ) === 0 ||
                        loadingPremium ||
                        isSavingLocation ||
                        isQuoteReadOnly ||
                        fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval' ||
                        isCalculateDisabled
                        ||
                        (Object.keys(validate(values))?.length >
                          0 &&
                          Object.keys(
                            validate(values)?.riskLocations,
                          )?.filter(
                            (k) =>
                              k?.toString()?.toLowerCase() !==
                              'stocklocations',
                          )?.length > 0) ||
                        (validate(values)?.riskLocations &&
                          validate(values)?.riskLocations?.length >
                          0 &&
                          validate(values)?.riskLocations?.stockLocations &&
                          validate(values)?.riskLocations?.stockLocations?.length > 0 &&
                          validate(values)?.riskLocations?.stockLocations?.filter(
                            (s) => Object.keys(s).length > 0,
                          )?.length > 0)
                      }
                      type={'button'}
                      size={'small'}
                      flat={false}
                      className={`${screenType?.toString()?.toLowerCase() ===
                        'mobile'
                        ? 'w-full'
                        : 'w-44'
                        } h-10`}
                      iconPre={
                        loadingPremium ? (
                          <FontAwesomeIcon
                            icon={faSpinner}
                            spin={true}
                            className="mr-3"
                          />
                        ) : errorPremium ? (
                          <FontAwesomeIcon
                            icon={faExclamationTriangle}
                            className="mr-3"
                          />
                        ) : (
                          <FontAwesomeIcon
                            icon={faCalculator}
                            className="mr-3"
                          />
                        )
                      }
                      onClick={async (_) => {
                        try {
                          setFieldValue(`addOnCovers.${'Basic Fire Cover'}.selected`, true)
                          let t
                          if (values?.riskLocations?.riskSumInsured?.buildingValue) {
                            t = Math.round(values?.riskLocations?.riskSumInsured?.buildingValue).toString()
                            if (t.length > 10) {
                              throw new Error(' Building Value cannot exceed ten digits ')
                            }
                          }
                          if (values?.riskLocations?.riskSumInsured?.totalBuildingSI) {
                            t = Math.round(values?.riskLocations?.riskSumInsured?.totalBuildingSI).toString()
                            if (t.length > 10) {
                              throw new Error(' Total Building SI cannot exceed ten digits ')
                            }
                          }
                          if (values?.riskLocations.stock.totalContentSI) {
                            t = Math.round(values?.riskLocations.stock.totalContentSI).toString()
                            if (t.length > 10) {
                              throw new Error(' Total Content SI cannot exceed ten digits ')
                            }
                          }
                          //addon start
                          let addon1 = 'Additional Living Expenses'
                          let addon3 = 'Involuntary Betterment Technological Advancement'
                          let addon4 = 'Loss Minimization Expenses'
                          let addon5 = 'Loss of Rent'
                          let addon6 = 'Personal Accident Cover Self'
                          let addon7 = 'Personal Accident Cover Spouse'
                          let addon8 = 'Rent for an Alternative Accommodation'
                          let addon9 = 'Specified Incidental Expenses Cover'
                          let x = coverlimiter()
                          //1
                          if (coverexcep(x, addon1)) {
                            if (values['addOnCovers'][addon1].selected === true) {
                              if (values[`addOnCovers`][addon1][`attributes`][`additionalLivingExpensesSI`].toString() === '0'
                                || values[`addOnCovers`][addon1][`attributes`][`additionalLivingExpensesSI`].toString() === '') {
                                throw new Error(' Additional Living Expenses SI field is required ')
                              }
                              t = values[`addOnCovers`][addon1][`attributes`][`additionalLivingExpensesSI`].toString()
                              if (t.length > 10) {
                                throw new Error(' Additional Living Expenses SI field length cannot be greater than 10')
                              }
                            }
                          }
                          //3
                          if (coverexcep(x, addon3)) {
                            if (values['addOnCovers'][addon3].selected === true) {
                              if (values[`addOnCovers`][addon3][`attributes`][`involuntaryBettermentTechnologicalAdvancementSI`].toString() === ''
                                || values[`addOnCovers`][addon3][`attributes`][`involuntaryBettermentTechnologicalAdvancementSI`].toString() === '0') {
                                throw new Error(' Involuntary Betterment Technological Advancement field is required ')
                              }
                              t = values[`addOnCovers`][addon3][`attributes`][`involuntaryBettermentTechnologicalAdvancementSI`].toString()
                              if (t.length > 10) {
                                throw new Error(' Involuntary Betterment Technological Advancement field length cannot be greater than 10')
                              }
                            }
                          }
                          //4
                          if (coverexcep(x, addon4)) {
                            if (values['addOnCovers'][addon4].selected === true) {
                              if (values[`addOnCovers`][addon4][`attributes`][`lossMinimizationExpensesSI`].toString() === ''
                                || values[`addOnCovers`][addon4][`attributes`][`lossMinimizationExpensesSI`].toString() === '0') {
                                throw new Error(' Loss Minimization Expenses SI field is required')
                              }
                              t = values[`addOnCovers`][addon4][`attributes`][`lossMinimizationExpensesSI`].toString()
                              if (t.length > 10) {
                                throw new Error(' Loss Minimization Expenses SI field length cannot be greater than 10')
                              }
                            }
                          }
                          //5
                          if (coverexcep(x, addon5)) {
                            if (values['addOnCovers'][addon5].selected === true) {
                              if (values[`addOnCovers`][addon5][`attributes`][`lossOfRentSI`].toString() === ''
                                || values[`addOnCovers`][addon5][`attributes`][`lossOfRentSI`].toString() === '0') {
                                throw new Error(' Loss of Rent field is required')
                              }
                              t = values[`addOnCovers`][addon5][`attributes`][`lossOfRentSI`].toString()
                              if (t.length > 10) {
                                throw new Error(' Loss of Rent field length cannot be greater than 10')
                              }
                              if (values[`addOnCovers`][addon5][`attributes`][`Indemnity_Period_Loss_of_Rent_In_Months`].toString() === '') {
                                throw new Error(' Loss of Rent in Months field is required')
                              }
                              if (values[`addOnCovers`][addon5][`attributes`][`rentPerMonth`].toString() === ''
                                || values[`addOnCovers`][addon5][`attributes`][`rentPerMonth`].toString() === '0') {
                                throw new Error(' rent Per Month field is required')
                              }
                              t = values[`addOnCovers`][addon5][`attributes`][`rentPerMonth`].toString()
                              if (t.length > 6) {
                                throw new Error(' rent Per Month field length cannot be greater than 6')
                              }
                            }
                          }
                          //6
                          if (coverexcep(x, addon6)) {
                            if (values['addOnCovers'][addon6].selected === true) {
                              //personalAccidentCoverSelfSI
                              if (values[`addOnCovers`][addon6][`attributes`][`personalAccidentCoverSelfSI`].toString() === ''
                                || values[`addOnCovers`][addon6][`attributes`][`personalAccidentCoverSelfSI`].toString() === '0') {
                                throw new Error(' Personal Accident Cover Self SI  field is required')
                              }
                              t = values[`addOnCovers`][addon6][`attributes`][`personalAccidentCoverSelfSI`].toString()
                              if (t.length > 10) {
                                throw new Error(' Personal Accident Cover Self SI  field length cannot be greater than 10')
                              }
                            }
                          }
                          //7
                          if (coverexcep(x, addon7)) {
                            if (values['addOnCovers'][addon7].selected === true) {
                              //personalAccidentCoverSpouseSI
                              if (values[`addOnCovers`][addon7][`attributes`][`personalAccidentCoverSpouseSI`].toString() === ''
                                || values[`addOnCovers`][addon7][`attributes`][`personalAccidentCoverSpouseSI`].toString() === '0') {
                                throw new Error(' Personal Accident Cover Spouse SI field is required')
                              }
                              t = values[`addOnCovers`][addon7][`attributes`][`personalAccidentCoverSpouseSI`].toString()
                              if (t.length > 10) {
                                throw new Error(' Personal Accident Cover Spouse SI field length cannot be greater than 10')
                              }
                            }
                          }
                          //8
                          if (coverexcep(x, addon8)) {
                            if (values['addOnCovers'][addon8].selected === true) {
                              if (values[`addOnCovers`][addon8][`attributes`][`rentForAlternativeAccommodationSI`].toString() === ''
                                || values[`addOnCovers`][addon8][`attributes`][`rentForAlternativeAccommodationSI`].toString() === '0') {
                                throw new Error(' Rent for an Alternative AccommodationSI field is required')
                              }
                              t = values[`addOnCovers`][addon8][`attributes`][`rentForAlternativeAccommodationSI`].toString()
                              if (t.length > 10) {
                                throw new Error(' Rent for an Alternative AccommodationSI length cannot be greater than 10')
                              }
                              if (values[`addOnCovers`][addon8][`attributes`][`accomodationIndemnityPeriodInMonths`].toString() === '') {
                                throw new Error(' Accomodation Indemnity Period In Months field is required')
                              }
                              if (values[`addOnCovers`][addon8][`attributes`][`accomodationRentPerMonth`].toString() === ''
                                || values[`addOnCovers`][addon8][`attributes`][`accomodationRentPerMonth`].toString() === '0') {
                                throw new Error(' Accomodation Rent Per Month field is required')
                              }
                              t = values[`addOnCovers`][addon8][`attributes`][`accomodationRentPerMonth`].toString()
                              if (t.length > 6) {
                                throw new Error(' Accomodation Rent Per Month field length cannot be greater than 6')
                              }
                            }
                          }
                          //9
                          if (coverexcep(x, addon9)) {
                            if (values['addOnCovers'][addon9].selected === true) {
                              //specifiedIncidentalExpensesCoverSI
                              if (values[`addOnCovers`][addon9][`attributes`][`specifiedIncidentalExpensesCoverSI`].toString() === ''
                                || values[`addOnCovers`][addon9][`attributes`][`specifiedIncidentalExpensesCoverSI`].toString() === '0') {
                                throw new Error(' Specified Incidental Expenses Cover SI field is required')
                              }
                              t = values[`addOnCovers`][addon9][`attributes`][`specifiedIncidentalExpensesCoverSI`].toString()
                              if (t.length > 10) {
                                throw new Error(' Specified Incidental Expenses Cover SI field length cannot be greater than 10')
                              }
                            }
                          }
                          setAlerts([]);
                          setErrorPremium(null);
                          setWarningMsg(null);
                          setLoadingPremium(true);
                          setAddOrProceedDisabled(true);
                          setChangeDisabled(true);
                          const selectedIntermediaryQuery =
                            fetchQuery({
                              query: GET_SELECTED_INTERMEDIARY,
                            });
                          const { data: selectedIntermediaryData } =
                            await selectedIntermediaryQuery;

                          const calculatePremiumFireQuery =
                            fetchQuery({
                              query: CALC_PREMIUM_QUOTE_FIRE_SA,
                              fetchPolicy: 'network-only',
                              variables:
                                getFireQuoteCalcPremiumVariables(
                                  selectedIntermediaryData?.selectedIntermediary,
                                  // riskLocationIndex,

                                ),
                            });


                          const { data: premiumData } =
                            await calculatePremiumFireQuery;
                          updateFireQuote({
                            //   currentTab: 1,
                            //riskcoverdata: values?.addOnCovers,
                            riskcoverdata: values?.addOnCovers,
                            otherDetails: {
                              premisesRentedOut: values?.otherDetails?.premisesRentedOut,
                              ownerOccupant: values?.otherDetails?.ownerOccupant,
                            },
                            loadingAndDiscount: {
                              discountPercentage: values?.loadingAndDiscount?.discountPercentage,
                              loadingPercentage: values?.loadingAndDiscount?.loadingPercentage,
                            },
                            //                    locationPremium: {
                            //   locationNetPremium: '',
                            //   locationGST: '',
                            //   locationTotalPremium: '',
                            //   stampDuty: '',
                            //   },
                            finalisedPremium: {
                              locationNetPremium:
                                values?.riskLocations
                                  ?.locationPremium?.locationNetPremium,
                              locationGST:
                                values?.riskLocations?.locationPremium?.locationGST,
                              stampDuty:
                                values?.riskLocations?.locationPremium?.stampDuty,
                              locationTotalPremium:
                                values?.riskLocations?.locationPremium?.locationTotalPremium,
                            },
                          });
                          setPremiumData(
                            premiumData?.fireCalculatePremiumSA,
                          );
                          setFieldValue(
                            `riskLocations.locationPremium.locationNetPremium`,
                            `${premiumData?.fireCalculatePremiumSA?.locationNetPremium}`,
                          );
                          setFieldValue(
                            `riskLocations.locationPremium.locationGST`,
                            `${premiumData?.fireCalculatePremiumSA?.locationGST}`,
                          );
                          setFieldValue(
                            `riskLocations.locationPremium.locationTotalPremium`,
                            `${premiumData?.fireCalculatePremiumSA?.locationTotalPremium}`,
                          );
                          setFieldValue(
                            `riskLocations.locationPremium.basicRate`,
                            `${premiumData?.fireCalculatePremiumSA?.basicRate}`,
                          );
                          // setFieldValue(
                          //   `riskLocations[${riskLocationIndex}].locationPremium.stampDuty`,
                          //   `${premiumData?.fireCalculatePremium?.stampDuty}`,
                          // );
                          setLoadingPremium(false);
                          setAddOrProceedDisabled(false);
                          setSaveDisabled(false);
                          setIsCalculateDisabled(true);
                          setChangeDisabled(false);
                          if (
                            premiumData?.fireCalculatePremiumSA
                              ?.warningMsg
                          ) {
                            setWarningMsg(
                              premiumData?.fireCalculatePremiumSA
                                ?.warningMsg,
                            );
                          }
                        } catch (error) {
                          // console.log("APIError",error?.message);
                          //error.message = error;
                          setWarningMsg(null);
                          setSaveDisabled(false);
                          //setIsCalculateDisabled(true);
                          setChangeDisabled(false);
                          setErrorPremium(error?.message);
                          setLoadingPremium(false);

                          setAlerts([
                            ...alerts,
                            {
                              header: 'Error Calculating Premium',
                              id: parseInt(uuidv4()),
                              content: (
                                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                                  <span>{error?.message === 'mandatory' ?
                                    `Please check mandatory feilds ` : error?.message}</span>
                                </div>
                              ),
                              type: 'error',
                              timeout: null,
                              disableClose: false,
                            },

                          ]);
                          // console.log("alerts",alerts);
                        }
                      }}
                    >
                      {loadingPremium
                        ? `Calculating...`
                        : `Calculate Premium`}
                    </Button>
                  </Text>
                  <Text
                    className={
                      screenType?.toString()?.toLowerCase() ===
                        'mobile'
                        ? 'w-full'
                        : ''
                    }
                  >
                    <Button
                      type={'button'}
                      size={'small'}
                      flat
                      className={`${screenType?.toString()?.toLowerCase() ===
                        'mobile'
                        ? 'w-full'
                        : 'w-44'
                        } h-10`}
                      iconPre={
                        isSavingLocation ? (
                          <FontAwesomeIcon
                            icon={faSpinner}
                            spin={true}
                            className="mr-3"
                          />
                        ) : errorSavingLocation ? (
                          <FontAwesomeIcon
                            icon={faExclamationTriangle}
                            className="mr-3"
                          />
                        ) : (
                          <FontAwesomeIcon
                            icon={faSave}
                            className="mr-3"
                          />
                        )
                      }
                      disabled={
                        ((premiumData?.locationNetPremium ===
                          null ||
                          premiumData?.locationNetPremium ===
                          undefined ||
                          premiumData?.locationNetPremium === '') &&
                          (premiumData?.locationGST === null ||
                            premiumData?.locationGST ===
                            undefined ||
                            premiumData?.locationGST === '') &&
                          (premiumData?.locationTotalPremium ===
                            undefined ||
                            premiumData?.locationTotalPremium ===
                            null ||
                            premiumData?.locationTotalPremium ===
                            '')) ||
                        loadingPremium ||
                        isSavingLocation ||
                        isQuoteReadOnly ||
                        (errorPremium !== null &&
                          errorPremium !== undefined &&
                          errorPremium !== '') ||
                        isSaveDisabled ||
                        fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval'
                      }
                      onClick={async (_) => {
                        try {
                          setAlerts([]);
                          setErrorSavingLocation(null);
                          setChangeDisabled(true);
                          setSavingLocation(true);
                          setAddOrProceedDisabled(true);
                          const saveLocationQuery = mutateQuery({
                            mutation: SAVE_LOCATION_FIRE,
                            variables: getSaveLocationVariables(values, riskCovers),
                          });
                          const { data: saveLocationData } =
                            await saveLocationQuery;
                          setFieldValue(
                            `riskLocations.riskLocationID`,
                            saveLocationData?.saveLocationSA
                              ?.riskLocationID,
                          );
                          if (
                            saveLocationData?.saveLocationSA
                              ?.successMsg
                          ) {
                            setAlerts([
                              ...alerts,
                              {
                                id: parseInt(uuidv4()),
                                content: (
                                  <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                                    <span>
                                      {
                                        saveLocationData
                                          ?.saveLocationSA?.successMsg
                                      }
                                    </span>
                                  </div>
                                ),
                                type: 'success',
                                timeout: 3000,
                                disableClose: false,
                              },
                            ]);
                          } else if (
                            saveLocationData?.saveLocationSA?.failMsg
                          ) {
                            setAlerts([
                              ...alerts,
                              {
                                id: parseInt(uuidv4()),
                                content: (
                                  <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                                    <span>
                                      {
                                        saveLocationData
                                          ?.saveLocationSA?.failMsg
                                      }
                                    </span>
                                  </div>
                                ),
                                type: 'error',
                                timeout: null,
                                disableClose: false,
                              },
                            ]);
                          }
                          let coversdata;
                          coversdata = getSaveLocationVariables(values, riskCovers)
                          updateFireQuote({
                            currentTab: 1,
                            riskcoverdata: coversdata?.input?.riskCovers,
                            otherDetails: {
                              premisesRentedOut: values?.otherDetails?.premisesRentedOut,
                              ownerOccupant: values?.otherDetails?.ownerOccupant,
                            },
                            loadingAndDiscount: {
                              discountPercentage: values?.loadingAndDiscount?.discountPercentage,
                              loadingPercentage: values?.loadingAndDiscount?.loadingPercentage,
                            },
                            locNetPremium: values?.riskLocations
                              ?.locationPremium?.locationNetPremium
                              ? `${values?.riskLocations?.locationPremium?.locationNetPremium}`
                              : '',
                            locGST: values?.riskLocations
                              ?.locationPremium?.locationGST
                              ? `${values?.riskLocations?.locationPremium?.locationGST}`
                              : '',
                            locTotalPremium: values?.riskLocations
                              ?.locationPremium?.locationTotalPremium
                              ? `${values?.riskLocations?.locationPremium?.locationTotalPremium}`
                              : '',
                            finalisedPremium: {
                              locationNetPremium:
                                values?.riskLocations?.locationPremium?.locationNetPremium,
                              locationGST:
                                values?.riskLocations?.locationPremium?.locationGST,
                              stampDuty:
                                values?.riskLocations?.locationPremium?.stampDuty,
                              locationTotalPremium:
                                values?.riskLocations?.locationPremium?.locationTotalPremium,
                            },
                          });
                          setSavingLocation(false);
                          setFieldValue(
                            `riskLocations.isLocationSaved`,
                            true,
                          );
                          // renderExpandedCards.current = [
                          //   ...renderExpandedCards?.current?.slice(
                          //     0,

                          //   ),
                          //   {
                          //     ...renderExpandedCards?.current,
                          //     locationCard: values?.riskLocations?.isLocationSaved
                          //       ? true
                          //       : false,
                          //   },
                          //   ...renderExpandedCards?.current?.slice(

                          //   ),
                          // ];
                          setAddOrProceedDisabled(false);
                          setChangeDisabled(false);
                          setSaveDisabled(true);
                          setIsCalculateDisabled(true);
                          setAddOrProceedDisabled(false);
                        } catch (error) {
                          setAddOrProceedDisabled(true);
                          setChangeDisabled(false);
                          setSavingLocation(false);
                          setIsCalculateDisabled(true);

                          setErrorSavingLocation(error?.message);
                          setAlerts([
                            ...alerts,
                            {
                              header: 'Error Saving Premium',
                              id: parseInt(uuidv4()),
                              content: (
                                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                                  <span>{error?.message}</span>
                                </div>
                              ),
                              type: 'error',
                              timeout: null,
                              disableClose: false,
                            },
                          ]);
                        }
                      }}
                    >
                      {isSavingLocation
                        ? `Saving...`
                        : `Save Details`}
                    </Button>
                  </Text>
                  {values?.riskLocations?.length > 1 &&
                    !isQuoteReadOnly && (
                      <Text
                        className={
                          screenType?.toString()?.toLowerCase() ===
                            'mobile'
                            ? 'w-full'
                            : ''
                        }
                      >
                        <Button
                          type={'button'}
                          size={'small'}
                          flat
                          className={`${screenType
                            ?.toString()
                            ?.toLowerCase() === 'mobile'
                            ? 'w-full'
                            : 'w-44'
                            } h-10`}
                          iconPre={
                            <FontAwesomeIcon
                              icon={faTrash}
                              className="mr-3"
                            />
                          }
                          disabled={
                            loadingPremium ||
                            isSavingLocation ||
                            isQuoteReadOnly ||
                            fireQuote?.status?.toString()?.toLowerCase() === 'pending uw approval'
                          }
                          onClick={async (_) => {
                            setShowDeleteModal(true);
                          }}
                        >
                          Remove
                        </Button>
                      </Text>
                    )}
                </Text>
              ),
            },
          ],
        }
        : null,
    ].filter((d) => d);
    const other_props = {
      flow: 'cols',
      textType: 'normal',
      repeat,
      repeatReadOnly: repeatReadOnly,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: false,
      useGlobalExpandablePaper: false,
      isSummaryRequiredUponExpanded: false,
      // summaryAlternate: (
      //   <Text
      //     className={
      //       'font-semibold text-lg flex space-x-2 items-center'
      //     }
      //     severity={'info'}
      //   >
      //     <Text>New Risk Location</Text>
      //     {values?.riskLocations?.length > 1 && !isQuoteReadOnly && (
      //         <Text>
      //           <Button
      //             type={'button'}
      //             flat
      //             size={'small'}
      //             className={'w-16 h-8'}
      //             disabled={loadingPremium || isSavingLocation}
      //             onClick={(_) => {
      //               setShowDeleteModal(true);
      //             }}
      //           >
      //             Remove
      //           </Button>
      //         </Text>
      //       )}
      //   </Text>
      // ),
      nullData: () => <Text severity="neutral">Not Captured</Text>,
    };
    return (
      <>
        <QuantaForm className={'space-y-4'}>
          <MixedGridGroup
            {...{
              data,
              ...other_props,
            }}
          />
        </QuantaForm>
        <NotificationList {...{ items: alerts }} />
      </>
    );
  }

  const RiskLocationDetailsForm = ({
    validate,
    initLocationObj,
    initStockLocationObj,
    riskCovers,
  }) => {
    const { values, setFieldValue } = useQuantaFormikContext();

    const [isAddOrProceedDisabled, setAddOrProceedDisabled] =
      useState(false);
    const [changeDisabled, setChangeDisabled] = useState(false);
    const [isSavingLocation, setSavingLocation] = useState(false);
    const [loadingPremium, setLoadingPremium] = useState(false);
    const [alerts, setAlerts] = useState([]);


    return (

      <Text className={'flex flex-col space-y-4'}>

        <CustomerSummary
          {...{

            changeDisabled,
            goToStep,
            fireQuote,
            loadingPremium: false,
            values,

          }}
        />
        <Text>
          <Text
            type={'title'}
            className={'w-full flex mb-4'}
            severity={'info'}
          >
            Risk Location Details
          </Text>
          <Text className={'flex flex-col space-y-1'}>
            {/* {values?.riskLocations?.map((_, idx) => {
              return (
                <NewRiskLocationForm
                  key={idx}
                  {...{
                    riskLocationIndex: idx,
                    validate,
                    initStockLocationObj,
                    setAddOrProceedDisabled,
                    setChangeDisabled,
                  }}
                />
              );
            })} */}
            <RiskLocationForm
              {...{
                validate,
                // initStockLocationObj,
                setAddOrProceedDisabled,
                setChangeDisabled,
                riskCovers,

              }}>
            </RiskLocationForm>
          </Text>
          <Text
            className={`flex ${screenType?.toString()?.toLowerCase() === 'mobile'
              ? 'flex-col space-y-4'
              : 'flex-row space-x-4 mt-8 mb-4'
              } justify-end items-center`}
          >
            {/* {!isQuoteReadOnly && (
              <Text
                className={
                  screenType?.toString()?.toLowerCase() === 'mobile'
                    ? 'w-full'
                    : ''
                }
              >
                <Button
                  type={'button'}
                  size={'small'}
                  flat
                  className={`w-${
                    screenType?.toString()?.toLowerCase() === 'mobile'
                      ? 'full'
                      : '44'
                  } h-10`}
                  onClick={(_) => {
                    renderExpandedCards.current = [
                      ...renderExpandedCards.current,
                      {
                        locationCard: true,
                        stockLocationCards: [false],
                      },
                    ];
                    setFieldValue('riskLocations', [
                      ...values?.riskLocations,
                      initLocationObj,
                    ]);
                  }}
                  disabled={
                    // values?.riskLocations?.filter(
                    //   (riskLocation) =>
                    //     !riskLocation?.isLocationSaved,
                    // )?.length > 0 || 
                    isAddOrProceedDisabled
                  }
                >
                  Add New Risk Location
                </Button>
              </Text>
            )} */}

            <Text
              className={`flex ${screenType?.toString()?.toLowerCase() === 'mobile'
                ? 'flex-col space-y-4'
                : 'flex-row space-x-4 mt-8 mb-4'
                } justify-end items-center`}
            >
              <Text
                className={
                  screenType?.toString()?.toLowerCase() === 'mobile'
                    ? 'w-full'
                    : ''
                }
              >
                <Button
                  flat={false}
                  size={'small'}
                  type="button"
                  className={
                    screenType?.toString()?.toLowerCase() === 'mobile'
                      ? 'w-full h-10'
                      : 'w-44 h-10'
                  }

                  disabled={
                    isAddOrProceedDisabled ||
                    loadingPremium ||
                    isSavingLocation ||
                    parseFloat(
                      values?.riskLocations
                        ?.locationSumInsured,
                    ) === 0 ||

                    values?.riskLocations?.isLocationSaved === false ||
                    isQuoteReadOnly ||
                    loadingPremium
                  }
                  iconPost={<FontAwesomeIcon icon={faChevronRight} />}
                  onClick={(_) => {
                    if (values?.riskLocations?.riskSumInsured?.carpetArea == '') {
                      alert('Please fill the all mandatory details and then proceed with Calculate Premium')
                      return 0;
                    }
                    updateFireQuote({
                      currentTab: 2,
                      tabDetails: {
                        ...fireQuote?.tabDetails,
                        riskLocationTabDetails: {
                          ...fireQuote?.tabDetails
                            ?.riskLocationTabDetails,
                          nonFloaterType: values?.riskLocations,
                          addOnCovers: values?.addOnCovers
                        },
                      },
                    });
                    goToStep(2);
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                >
                  Proceed{' '}
                </Button>
              </Text>
            </Text>

          </Text>
        </Text>
      </Text>
    );
  };

  if (loadingRiskDropdownDetails || loadingCoverFireSA || loadingintermediary || loadingCostOfConstruction) {
    return (
      <Text className={'min-h-screen'}>
        <Loading />
      </Text>
    );
  }

  // if (loadingriskdropdownSA) {
  //   return (
  //     <Text className={'min-h-screen'}>
  //       <Loading />
  //     </Text>
  //   );
  // }
  if (errorRiskDropdownDetails || errorCoverFireSA || errorCostOfConstruction) {
    return (
      <Text className={'min-h-screen'}>
        <Error error={errorRiskDropdownDetails
          || errorCoverFireSA || errorCostOfConstruction} />
      </Text>
    );
  }
  // if (errorriskdropdownSA) {
  //   return (
  //     <Text className={'min-h-screen'}>
  //       <Error error={errorRiskDropdownDetails} />
  //     </Text>
  //   );
  // }
  const {
    PRD_classOfConstruction,
    PRD_distanceFromWaterbody,
    PRD_securityProvisions,
    PRD_occupancy,
    PRD_fireExtinguisherApplisDtls,
    PRD_MaxLocationSI,
    PRD_maxFloaterLocLimit,
    PRD_previousClaimExperience,
    //PRD_costOfConstruction,
  } = dataRiskDropdownDetails;
  const {
    coverListForSA
  } = dataCoverFireSA;
  const { PRD_costOfConstruction } = dataCostOfConstruction;
  const newfunction = (x, y) => {

    for (let i = 0; i < x.length; i++) {
      if (x[i].covername.toLowerCase().toString() === y.toLowerCase().toString()) {

        return x[i].percent
      }

    }

  }
  const coverexcep = (x, y) => {
    let z = false
    for (let i = 0; i < x.length; i++) {
      if (x[i].covername.toLowerCase().toString() === y.toLowerCase().toString()) {
        z = true
      }
    }
    return z
  }
  const coverlimiter2 = (values, setFieldValue) => {
    let riskInput = [];
    coverListForSA?.riskCovers?.forEach((r) => {
      // console.log("1039 ......r : ",r);
      let covers = [];

      r?.covers
        ?.filter(
          (c) => values[`addOnCovers`][c?.name]?.selected,
        )
        ?.forEach((c) => {
          //  console.log("1-----",values[`riskLocations`][`addOnCovers`][c?.name]);
          const { selected, attributes, ...rest } = c;
          let attributesArr = [];
          c?.attributes?.forEach((attribute) => {
            attributesArr.push({
              ...attribute,
              value: attribute?.showOnScreen
                ? `${values[`addOnCovers`][`${c?.name}`][
                `attributes`
                ][`${attribute?.name}`]
                }`
                : `${attribute?.defaultValue}`,
            });
          });
          covers.push({
            ...rest,
            attributes: [...attributesArr],
          });
        });
      if (covers?.length !== 0) {
        riskInput.push({
          riskType: r?.riskType,
          covers,
        });
      }
    });
    for (let i = 0; i < riskInput.length; i++) {
      for (let j = 0; j < riskInput[i].covers.length; j++) {
        for (
          let k = 0;
          k < riskInput[i].covers[j].attributes.length;
          k++
        ) {
          setFieldValue(
            `addOnCovers.${riskInput[i].covers[j].name}.attributes.${riskInput[i].covers[j].attributes[k].name}`,
            values?.riskLocations?.stock?.totalSumInsured *
            riskInput[i]?.covers[j]?.attributes[k]?.siPercentage


          );
          // values[`addOnCovers`][`${riskInput[i].covers[j].name}`][attributes][`${riskInput[i].covers[j].attributes[k].name}`]
          //  = values?.riskLocations?.stock?.totalSumInsured *
          //  riskInput[i].covers[j].attributes[k].siPercentage
          // console.log('coverlimiter2 set field')
        }
      }
    }
  }
  const coverlimiter = () => {
    let coverdata = [];
    let coverAttributes = [];
    for (let i = 0; i < coverListForSA?.riskCovers.length; i++) {
      for (let j = 0; j < coverListForSA?.riskCovers[i]?.covers?.length; j++) {
        for (
          let k = 0;
          k < coverListForSA?.riskCovers[i]?.covers[j]?.attributes?.length;
          k++
        ) {
          if (coverListForSA?.riskCovers[i].covers[j].attributes[k].name?.toLowerCase()?.search('si') !== -1)
            coverdata?.push({
              covername: coverListForSA?.riskCovers[i].covers[j].name,
              attributename: coverListForSA?.riskCovers[i].covers[j].attributes[k].name,
              percent: coverListForSA?.riskCovers[i].covers[j].attributes[k].siPercentage,
              pctAmt: coverListForSA?.riskCovers[i]?.covers[j]?.pctAmt,
              valAmt: coverListForSA?.riskCovers[i]?.covers[j]?.valAmt
            });
          coverAttributes?.push({
            covername: coverListForSA?.riskCovers[i].covers[j].name,
            pctAmt: coverListForSA?.riskCovers[i]?.covers[j]?.pctAmt,
            valAmt: coverListForSA?.riskCovers[i]?.covers[j]?.valAmt
          })
        }
      }
    }
    //setcoverlimit(coverAttributes)
    //setcovercontrol(coverdata)
    return coverdata
  }
  const getinitialValues = () => {
    const initObj = {
      riskLocations:
      {
        riskLocationID: '',
        isDeleted: false,
        occupancy: {
          code: '',
          value: '',
          occupancySection: '',
          occupancyRate: '',
          riskCode: '',
          rateCode: '',
          riskGrade: '',
          riskGradeDefinition: '',
          riskPreference: '',
          gicClass: '',
          stfiRate: '',
          rsmdRate: '',
        },
        isLocationSaved: false,
        addressDetails: {
          addressLine1: '',
          pincode: '',
          state: '',
          eqZone: '',
          district: '',
          isSamePremise: false,
          locationCode: '',
          locationDesc: '',
        },

        riskSumInsured: {
          costOfConstruction: '',
          carpetArea: '',
          buildingValue: '',
          additionalStructure: '',
          totalBuildingSI: '',
          ratePerMille: '',

        },
        stock: {
          generalContentSI: '',
          additionalContent: '',
          additionalContentSI: '',
          valuableContent: '',
          valuableContentSI: '',
          totalContentSI: '',
          totalSumInsured: '',
        },
        stockLocations: [
          {
            isDeleted: false,
            floaterLocationID: '',
            addressLine1: '',
            pincode: '',
            state: '',
            eqZone: '',
            district: '',
            locationCode: '',
            locationDesc: '',
          },
        ],
        otherDetails: {
          premisesRentedOut: 'No',
          ownerOccupant: 'No',
        },
        addOnCovers: {},
        riskCovers: coverListForSA?.riskCovers,
        // addOnCovers: {
        //   premisesRentedOut: 'No',
        //   lossOfRent: '',
        //   ownerOccupant: 'No',
        //   // securityProvisions: '',
        //   rentPerMonth: '',
        // },
        loadingAndDiscount: {
          discountPercentage: '',
          loadingPercentage: '',
        },
        previousClaimDetails: {
          claimExperience: '',
        },
        locationPremium: {
          locationNetPremium: '',
          locationGST: '',
          locationTotalPremium: '',
          stampDuty: '',
        },
      },

    };
    if (
      fireQuote?.riskcoverdata &&
      fireQuote?.riskcoverdata.length > 0
    ) {
      coverListForSA?.riskCovers?.forEach((riskCover) => {
        riskCover?.covers?.forEach((cover) => {
          initObj[`riskLocations`][`addOnCovers`][`${cover?.name}`] = {
            selected: fireQuote?.riskcoverdata
              ?.find(
                (addOnCover) =>
                  addOnCover?.riskType?.toLowerCase() ===
                  riskCover?.riskType?.toLowerCase(),
              )
              ?.covers?.find(
                (c) =>
                  c?.name?.toLowerCase() ===
                  cover?.name?.toLowerCase(),
              )
              ? true
              : false,
            attributes: {},
          };
          cover?.attributes
            ?.filter((attribute) => attribute?.showOnScreen)
            ?.forEach((attribute) => {
              if (attribute?.name === 'Terrorism Third Party Liability' || attribute?.name === 'Terrorism Political Violence') {
                initObj[`riskLocations`][`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = fireQuote?.riskcoverdata
                  ?.find(
                    (addOnCover) =>
                      addOnCover?.riskType?.toLowerCase() ===
                      riskCover?.riskType?.toLowerCase(),
                  )
                  ?.covers?.find(
                    (c) =>
                      c?.name?.toLowerCase() ===
                      cover?.name?.toLowerCase(),
                  )
                  ?.attributes?.find(
                    (a) =>
                      a?.name?.toLowerCase() ===
                      attribute?.name?.toLowerCase(),
                  )?.value?.toString() === 'true'
                    ? true
                    : false;
              } else {
                initObj[`riskLocations`][`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = fireQuote?.riskcoverdata
                  ?.find(
                    (addOnCover) =>
                      addOnCover?.riskType?.toLowerCase() ===
                      riskCover?.riskType?.toLowerCase(),
                  )
                  ?.covers?.find(
                    (c) =>
                      c?.name?.toLowerCase() ===
                      cover?.name?.toLowerCase(),
                  )
                  ?.attributes?.find(
                    (a) =>
                      a?.name?.toLowerCase() ===
                      attribute?.name?.toLowerCase(),
                  )?.value
                    ? fireQuote?.riskcoverdata
                      ?.find(
                        (addOnCover) =>
                          addOnCover?.riskType?.toLowerCase() ===
                          riskCover?.riskType?.toLowerCase(),
                      )
                      ?.covers?.find(
                        (c) =>
                          c?.name?.toLowerCase() ===
                          cover?.name?.toLowerCase(),
                      )
                      ?.attributes?.find(
                        (a) =>
                          a?.name?.toLowerCase() ===
                          attribute?.name?.toLowerCase(),
                      )?.value
                    : attribute?.value
                      ? attribute?.value
                      : attribute?.defaultValue
                        ? attribute?.defaultValue
                        : '';
              }
            });
        });
      });
    } else {
      // console.log("3862inside else" );
      coverListForSA?.riskCovers?.forEach((riskCover) => {
        // console.log("3864 : inisid else : ",riskCover),
        riskCover?.covers?.forEach((cover) => {
          // console.log("3866 : inisidelse : ",cover),
          initObj[`riskLocations`][`addOnCovers`][`${cover?.name}`] = {
            selected: cover?.selected ? cover?.selected : false,
            attributes: {},
          };
          cover?.attributes
            ?.filter((attribute) => attribute?.showOnScreen)
            ?.forEach((attribute) => {
              initObj[`riskLocations`][`addOnCovers`][`${cover?.name}`][`attributes`][
                `${attribute?.name}`
              ] = attribute?.value
                  ? attribute?.value
                  : attribute?.defaultValue
                    ? attribute?.defaultValue
                    : '';
            });
        });
      });
    }

    return {
      addOnCovers: initObj?.riskLocations?.addOnCovers,
      otherDetails: {
        premisesRentedOut: fireQuote?.otherDetails?.premisesRentedOut
          ? fireQuote?.otherDetails?.premisesRentedOut
          : 'No',
        ownerOccupant: fireQuote?.otherDetails?.ownerOccupant
          ? fireQuote?.otherDetails?.ownerOccupant
          : 'No',
      },
      loadingAndDiscount: {
        discountPercentage: fireQuote?.loadingAndDiscount?.discountPercentage
          ? fireQuote?.loadingAndDiscount?.discountPercentage
          : '0',
        loadingPercentage: fireQuote?.loadingAndDiscount?.loadingPercentage
          ? fireQuote?.loadingAndDiscount?.loadingPercentage
          : '0',
      },
      riskLocations:
        fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType
          ?.length === 0
          ? initObj?.riskLocations
          : fireQuote?.tabDetails?.riskLocationTabDetails
            ?.nonFloaterType,
      riskLocations: {
        addressDetails: {
          district: fireQuote?.district
            ? fireQuote?.district
            : '',
          pincode: fireQuote?.pincode
            ? fireQuote?.pincode
            : '',
          state: fireQuote?.state
            ? fireQuote?.state
            : '',
          addressLine1: fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.addressLine1
            ? fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.addressDetails?.addressLine1
            : '',
        },
        isLocationSaved: false,
        riskSumInsured: {
          carpetArea: fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.carpetArea ?
            fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.carpetArea
            : '',
          buildingValue: fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.buildingValue ?
            fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.buildingValue
            : '',
          additionalStructure: fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.additionalStructure ?
            fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.riskSumInsured?.additionalStructure
            : '',
        },

        stock: {
          generalContentSI: fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.generalContentSI ?
            fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.generalContentSI : '',
          additionalContent:
            fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.additionalContent ?
              fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.additionalContent : '',
          additionalContentSI:
            fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.additionalContentSI ?
              fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.additionalContentSI : '',
          valuableContent:
            fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.valuableContent ?
              fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.valuableContent : '',
          valuableContentSI:
            fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.valuableContentSI ?
              fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.valuableContentSI : '',
          totalContentSI:
            fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.totalContentSI ?
              fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.totalContentSI : '',
          totalSumInsured:
            fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.totalSumInsured ?
              fireQuote?.tabDetails?.riskLocationTabDetails?.nonFloaterType?.stock?.totalSumInsured : '',
        },
      },
    };
  }



  const initialValues = getinitialValues();

  return (
    <div>
      {!initialValues && (
        <div className="min-h-screen">
          <Loading />
        </div>
      )}
      {initialValues && (
        <QuantaFormik
          innerRef={props?.riskLocationFormRef}
          enableReinitialize={true}
          {...{
            initialValues,
            validate,
            onSubmit,
          }}
        >
          <RiskLocationDetailsForm
            {...{
              validate,
              initLocationObj: initialValues?.riskLocations,//initObj?.riskLocations,
              riskCovers: coverListForSA?.riskCovers,
            }}
          />
        </QuantaFormik>
      )}
    </div>
  );
}
